<template>
  <customModal :containermd="true" @closeModal="closemodaltwo()">
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.field customization") }}: {{ fieldname }}
      </h4>
    </template>

    <template #body>
      <div id="modalcontents" class="modalcontents">
        <div class="row mx-0">
          <div class="col-lg-12">
            <!-- Tabs -->
            <ul class="modal-nav modal-nav-tabs" role="tablist">
              <li>
                <a
                  href="#tab-1"
                  class="modal-nav-link"
                  :class="{ 'active-modal-tab': refreshFlags.general }"
                  data-toggle="tab"
                  @click="handleTabClick('general')"
                  >{{ $t("navigations.general") }}</a
                >
              </li>
              <!-- <li v-if="inputValidationElements.indexOf(selectedmenu) !== -1">
               <a href="#" class="modal-nav-link" @click.prevent="handleTabClick('validation')">{{ $t("navigations.validation") }}</a>
              </li> -->
              <li v-if="inputValidationElements.indexOf(selectedmenu) !== -1">
                <a
                  href="#tab-2"
                  class="modal-nav-link"
                  :class="{ 'active-modal-tab': refreshFlags.validation }"
                  data-toggle="tab"
                  @click="handleTabClick('validation')"
                  >{{ $t("navigations.validation") }}</a
                >
              </li>
              <li v-if="inputValidationElements.indexOf(selectedmenu) !== -1">
                <a
                  href="#tab-3"
                  class="modal-nav-link"
                  :class="{ 'active-modal-tab': refreshFlags.dependencies }"
                  data-toggle="tab"
                  @click="handleTabClick('dependencies')"
                  >{{ $t("navigations.dependencies") }}</a
                >
              </li>
              <li
                v-if="
                  selectedmenu === 'textbox' ||
                  selectedmenu === 'text' ||
                  selectedmenu === 'date'
                "
              >
                <a
                  href="#tab-4"
                  class="modal-nav-link"
                  :class="{ 'active-modal-tab': refreshFlags.calculations }"
                  data-toggle="tab"
                  @click="handleTabClick('calculations')"
                  >{{ $t("navigations.calculations") }}</a
                >
              </li>
            </ul>

            <div class="ibox-tab-content">
              <!-- ============ GENERAL ============ -->
              <div role="tabpanel" v-if="refreshFlags.general">
                <!-- TEXTBOX/TEXT -->
                <div
                  v-if="selectedmenu === 'textbox' || selectedmenu === 'text'"
                  class="fieldentry"
                >
                  <div class="ibox-content-edit row">
                    <div class="col-md-6">
                      <div class="textgroup mb-2">
                        <label class="mb-0" for="textboxtext">{{
                          $t("navigations.text box label")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="labeltext"
                          id="textboxtext"
                          :disabled="isformlocked"
                        />
                      </div>
                      <div class="textgroup mb-2">
                        <label class="mb-0" for="instructionstextbox">{{
                          $t("navigations.field name")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="fieldname"
                          maxlength="30"
                          id="instructionstextbox"
                          :disabled="isformlocked"
                        />
                      </div>
                      <div class="textgroup">
                        <label class="mb-0">{{
                          $t("navigations.validations")
                        }}</label>
                        <Multiselect
                          :disabled="isformlocked"
                          class="multiselect-theme"
                          mode="multiple"
                          v-model="values"
                          @change="valuesChanged"
                          @select="changeArray"
                          @deselect="deselectedOption"
                          @clear="clearValues"
                          :options="options"
                          :hideSelected="false"
                          :closeOnSelect="false"
                          :placeholder="$t('navigations.select validations')"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                    <div
                      class="form-group col-12 px-0 my-2"
                      v-if="generalValidations.length > 0"
                    >
                      <div
                        class="ibox-content p-3 mb-2"
                        v-for="(validation, index) in generalValidations"
                        :key="'gv-' + index"
                      >
                        <div class="d-flex justify-content-between">
                          <label
                            >Validation for
                            <b>{{ validation.condition }}</b></label
                          >
                          <div
                            class="position-relative cursor-pointer"
                            v-if="!isformlocked"
                            @click.prevent="deleteMessage('general', index)"
                          >
                            <img
                              width="17"
                              src="../../assets/delete_doc.png"
                              alt="delete message"
                            />
                            <div class="tool-tip">
                              {{ $t("navigations.delete validation") }}
                            </div>
                          </div>
                        </div>

                        <!-- Character length range -->
                        <div
                          class="textgroup mb-3"
                          v-if="validation.condition === 'CHARACTERLIMITRANGE'"
                        >
                          <div class="optgroup">
                            <div>
                              <label>{{ $t("navigations.min length") }}</label>
                              <input
                                v-model.number="minlength"
                                min="0"
                                type="number"
                                class="form-control"
                              />
                              <span v-if="rangeErrors[0]" class="errormsg">{{
                                $t("navigations.please enter a value")
                              }}</span>
                            </div>
                            <div>
                              <label>{{ $t("navigations.max length") }}</label>
                              <input
                                v-model.number="maxlength"
                                min="0"
                                type="number"
                                class="form-control"
                              />
                              <span v-if="rangeErrors[1]" class="errormsg">{{
                                $t("navigations.please enter a value")
                              }}</span>
                            </div>
                          </div>
                          <div v-if="rangeErrors[4] || rangeErrors[5]">
                            <span class="errormsg" v-if="rangeErrors[4]">{{
                              $t(
                                "navigations.value entered on min length must be lower than value entered on max length field"
                              )
                            }}</span>
                            <span class="errormsg" v-if="rangeErrors[5]">{{
                              $t(
                                "navigations.value entered on max length cannot be zero"
                              )
                            }}</span>
                          </div>
                        </div>

                        <!-- Numeric range -->
                        <div
                          class="form-group textgroup mb-3"
                          v-if="validation.condition === 'NUMERICRANGE'"
                        >
                          <div class="optgroup">
                            <div>
                              <label>{{ $t("navigations.min value") }}</label>
                              <input
                                v-model.number="minvalue"
                                :disabled="isformlocked"
                                min="0"
                                type="number"
                                class="form-control"
                              />
                              <span v-if="rangeErrors[2]" class="errormsg">{{
                                $t("navigations.please enter a value")
                              }}</span>
                            </div>
                            <div>
                              <label>{{ $t("navigations.max value") }}</label>
                              <input
                                v-model.number="maxvalue"
                                :disabled="isformlocked"
                                min="0"
                                type="number"
                                class="form-control"
                              />
                              <span v-if="rangeErrors[3]" class="errormsg">{{
                                $t("navigations.please enter a value")
                              }}</span>
                            </div>
                          </div>
                          <div>
                            <span class="errormsg" v-if="rangeErrors[6]">{{
                              $t(
                                "navigations.value entered on min value must be lower than value entered on max value field"
                              )
                            }}</span>
                            <span class="errormsg" v-if="rangeErrors[7]">{{
                              $t(
                                "navigations.value entered on max value cannot be zero"
                              )
                            }}</span>
                          </div>
                        </div>

                        <!-- Message type radios -->
                        <div>
                          <label :for="'optionRadiosExclusion' + index">
                            <input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked"
                              value="Exclusion"
                              :id="'optionRadiosExclusion' + index"
                            />
                            <span class="mr-1">{{
                              $t(
                                "navigations.exclusion(blocks further data entry)"
                              )
                            }}</span>
                          </label>
                          <img
                            class="mb-1"
                            src="../../assets/img/exclusion.png"
                          />
                        </div>
                        <div>
                          <label :for="'optionRadiosError' + index">
                            <input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked"
                              value="Alert"
                              :id="'optionRadiosError' + index"
                            />
                            <span class="mr-1">{{
                              $t(
                                "navigations.error(prevents saving that field value)"
                              )
                            }}</span>
                          </label>
                          <img class="mb-1" src="../../assets/img/alert.png" />
                        </div>
                        <div>
                          <label :for="'optionRadiosWarning' + index">
                            <input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked"
                              value="Warning"
                              :id="'optionRadiosWarning' + index"
                            />
                            <span class="mr-1">{{
                              $t("navigations.warning")
                            }}</span>
                          </label>
                          <img
                            class="mb-1"
                            src="../../assets/img/warning.png"
                          />
                        </div>
                        <div>
                          <label :for="'optionRadiosInformation' + index">
                            <input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked"
                              value="Information"
                              :id="'optionRadiosInformation' + index"
                            />
                            <span class="mr-1">{{
                              $t("navigations.information")
                            }}</span>
                          </label>
                          <img class="mb-1" src="../../assets/img/info.png" />
                        </div>
                        <div
                          v-if="
                            generalValidationsError[index] &&
                            generalValidationsError[index][0]
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please choose a value") }}
                        </div>

                        <!-- Message -->
                        <div class="col-12 px-0">
                          <label for="message">{{
                            $t("navigations.message")
                          }}</label>
                          <textarea
                            class="form-control"
                            v-model="validation.message"
                            :disabled="isformlocked"
                            id="message"
                            minlength="10"
                            spellcheck="true"
                          ></textarea>
                          <div
                            v-if="
                              generalValidationsError[index] &&
                              generalValidationsError[index][1]
                            "
                            class="errormsg py-1 mx-0"
                          >
                            {{ $t("navigations.please enter a value") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- headding starts -->
                <div
                  v-if="refreshFlags.general && selectedmenu == 'header'"
                  class="fieldentry"
                >
                  <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.heading") }}</h5>
                </div> -->
                  <div class="ibox-content-edit">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label" for="headdingtext">{{
                          $t("navigations.add heading")
                        }}</label>
                        <input
                          type="text"
                          v-model="labeltext"
                          class="form-control"
                          id="headdingtext"
                          placeholder=""
                          :disabled="isformlocked == true"
                        />
                      </div>
                 
                    </div>
                     <div class="form-group row">
                                    <div class="col-md-12">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                    </div>
                    <!-- <div class="form-group textgroup">
                    <label class="col-form-label" for="instructionstext"
                      >Field Name</label
                    >
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstext"
                      placeholder="Field Name"
                    />
                  </div> -->
                  </div>
                </div>
                <!-- subheading starts -->
                <div
                  v-if="refreshFlags.general && selectedmenu == 'subHeader'"
                  class="fieldentry"
                >
                  <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.sub heading") }}</h5>
                </div> -->
                  <div class="ibox-content-edit">
                    <div class="form-group">
                      <label class="mb-0" for="subheaddingtext">{{
                        $t("navigations.add sub heading")
                      }}</label>
                      <input
                        type="text"
                        v-model="labeltext"
                        class="form-control"
                        id="subheaddingtext"
                        placeholder=""
                        :disabled="isformlocked == true"
                      />
                    
                    </div>
                             <div class="form-group">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                   

                    <!-- <div class="form-group textgroup">
                    <label for="instructionstext">Field Name</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstext"
                      placeholder="Field Name"
                    />
                  </div> -->
                  </div>
                </div>
                <!-- GRID -->
                <div
                  v-if="refreshFlags.general && selectedmenu === 'grid'"
                  class="fieldentry"
                >
                  <div class="ibox-title">
                    <h5>{{ $t("navigations.grid") }}</h5>
                    <nav class="nav nav-pills flex-column flex-sm-row">
                      <a
                        :class="gridgeneral"
                        aria-current="page"
                        @click.prevent="selectconf('general')"
                        >{{ $t("navigations.general") }}</a
                      >
                      <a
                        :class="gridconfiguration"
                        @click.prevent="selectconf('configuration')"
                        >{{ $t("navigations.configuration") }}</a
                      >
                    </nav>
                  </div>

                  <div
                    v-if="gridoption === 'general'"
                    class="ibox-content-edit"
                  >
                    <div class="form-group">
                      <label for="textareatext">{{
                        $t("navigations.grid label")
                      }}</label>
                      <input
                        type="text"
                        v-model="labeltext"
                        class="form-control"
                        id="textareatext"
                      />
                    </div>
                    <div class="form-group textgroup">
                      <label for="instructionstextarea">{{
                        $t("navigations.field name")
                      }}</label>
                      <input
                        type="text"
                        v-model="fieldname"
                        class="form-control"
                        id="instructionstextarea"
                      />
                    </div>
                  </div>

                  <div v-if="gridoption === 'configuration'">
                    <div class="ibox-content-edit flextable">
                      <div class="addfieldtable">
                        <div>{{ $t("navigations.row label") }}</div>
                        <div
                          class="rowcolmn"
                          v-for="(gridrow, index) in gridrows"
                          :key="'row-' + index"
                        >
                          <input
                            class="form-control"
                            v-model="griddata[0].Rows[index]"
                            type="text"
                          />
                          <div v-if="index === 0">
                            <i
                              class="fa fa-plus-square-o iconstyle"
                              aria-hidden="true"
                              @click.prevent="incrementrows"
                            ></i>
                          </div>
                          <div v-else>
                            <i
                              class="fa fa-times-circle-o closeiconstyle"
                              aria-hidden="true"
                              @click.prevent="removerowsrows(index)"
                            ></i>
                          </div>
                        </div>
                      </div>

                      <div class="addfieldtable">
                        <div>{{ $t("navigations.column label") }}</div>
                        <div
                          class="rowcolmn"
                          v-for="(gridcolumn, index) in gridcolumns"
                          :key="'col-' + index"
                        >
                          <input
                            class="form-control"
                            v-model="griddata[0].Columns[index]"
                            type="text"
                          />
                          <div v-if="index === 0">
                            <i
                              class="fa fa-plus-square-o iconstyle"
                              aria-hidden="true"
                              @click.prevent="incrementcolumns"
                            ></i>
                          </div>
                          <div v-else>
                            <i
                              class="fa fa-times-circle-o closeiconstyle"
                              aria-hidden="true"
                              @click.prevent="removecolumns(index)"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-md-10 rowfieldtype"
                      v-for="(gridrow, index) in gridrows"
                      :key="'ft-' + index"
                    >
                      <label>Field Type of Row {{ gridrow }}</label>
                      <select
                        class="col-md-10 form-control"
                        v-model="griddata[0].Fieldtypes[index]"
                        name="fieldtype"
                      >
                        <option value="date">Date</option>
                        <option value="number">Number</option>
                        <option value="text">Text</option>
                        <option value="time">Time</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- summary -->
                <div
                  v-if="refreshFlags.general && selectedmenu === 'summary'"
                  class="fieldentry"
                >
                  <div class="ibox-content-edit">
                    <div class="form-group">
                      <label for="textboxtext">{{
                        $t("navigations.summary")
                      }}</label>
                      <textarea
                        class="form-control"
                        v-model="labeltext"
                        id="textboxtext"
                      ></textarea>
                    </div>
                    <div class="form-group textgroup">
                      <label for="instructionstextbox">{{
                        $t("navigations.field name")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="fieldname"
                        id="instructionstextbox"
                      />
                    </div>
                  </div>
                </div>

                <!-- calculation (field type, not the tab) -->
                <div
                  v-if="refreshFlags.general && selectedmenu === 'calculation'"
                  class="fieldentry"
                >
                  <div class="ibox-content-edit">
                    <div class="form-group">
                      <label for="calculatedfieldtext">{{
                        $t("navigations.calculation label")
                      }}</label>
                      <input
                        type="text"
                        v-model="labeltext"
                        class="form-control"
                        id="calculatedfieldtext"
                      />
                    </div>
                    <div class="form-group textgroup">
                      <label for="instructionscalculated">{{
                        $t("navigations.field name")
                      }}</label>
                      <input
                        type="text"
                        v-model="fieldname"
                        class="form-control"
                        id="instructionscalculated"
                      />
                    </div>
                    <div class="form-group textgroup">
                      <label for="instructionstime">{{
                        $t("navigations.operations")
                      }}</label>
                      <textarea
                        class="form-control"
                        v-model="calculate.operations"
                        name="calculation"
                        id="instructionstime"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!-- dropdown starts -->
              <div
                v-if="refreshFlags.general && selectedmenu === 'dropdown'"
                class="fieldentry"
              >
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.dropdown") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="row">
                   <div class="col-lg-6">
                  <div class="form-group textgroup mb-2">
        <label for="dropdowntext" class="mb-0">
          {{ $t("navigations.dropdown label") }}
        </label>
        <input
          type="text"
          class="form-control"
          v-model="labeltext"
          id="dropdowntext"
          placeholder=""
          :disabled="isformlocked === true"
        />
      </div>

      <!-- Select Option Group -->
      <div class="form-group textgroup mb-2">
        <label for="optiongroup"  class="mb-0">
          {{ $t("navigations.select option group") }}
        </label>
        <select
          class="form-select pb-0 horizondalscroll"
          id="optiongroup"
          v-model="selectedmodel"
          @change.prevent="dropdownmodelchange()"
          :disabled="isformlocked === true"
        >
          <option value="" disabled>
            {{ $t("navigations.select") }}
          </option>
          <option
            v-for="models in optiongroups.results"
            :key="models.id"
            :value="models"
          >
            {{ models.label }}
          </option>
        </select>
      </div>

                  <div class="form-group textgroup mb-2">
                    <label for="instructionsdropdown" class="mb-0">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="fieldname"
                      maxlength="30"
                      id="instructionsdropdown"
                      placeholder=""
                      :disabled="isformlocked == true"
                    />
                  </div>
                   </div>
                         <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="6"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                    </div>
                  <div class="form-group textgroup">
                   <div class="row mb-3 pr-3 d-flex align-items-center">
                      <div class="col-lg-2 pr-0">
                        <label class="mt-3 mb-0" for="optionscheckbox">{{$t("navigations.add options")}} : </label>
                      </div>
                      <div class="col-lg-4 px-2">
                        <label class="mb-0">{{$t("navigations.code value")}}</label>
                        <input
                          ref="codeValueInput"
                          type="text"
                          class="form-control"
                          v-model="radiovalues"
                          maxlength="50"
                        />
                      </div>

                      <div class="col-lg-5 pr-0">
                        <label class="mb-0">{{
                          $t("navigations.option name")
                        }}</label>
                        <input
                          type="text"
                          ref="optionNameInput"
                          class="form-control"
                          v-model="radiooptions"
                          id="optionscheckbox"
                          maxlength="50"
                        />
                      </div>
                      
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <!-- Add button -->
                        <div class="d-flex justify-content-end">
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="addradiooptions()"
                            v-if="editingOption === null"
                            :disabled="
                              radiovalues == '' ||
                              radiovalues == null ||
                              radiooptions == '' ||
                              radiooptions == null
                            "
                          >
                            {{ $t("navigations.add") }}
                          </button>
                          <!-- Update button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="UpdateDropdownoptions()"
                            v-else
                          >
                            {{ $t("navigations.update") }}
                          </button>
                          <div style="margin-left: 10px"></div>
                          <!-- Cancel button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="cancelEditDropdown()"
                            v-if="editingOption !== null"
                            style="background-color: red; color: white"
                          >
                            {{ $t("navigations.cancel") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group textgroup"
                    style="overflow-y: auto; max-height: 250px"
                  >
                    <!-- <label for="optionslistcheckbox">Options</label> -->
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>{{ $t("navigations.code value") }}</th>
                          <th>{{ $t("navigations.option name") }}</th>
                          <th class="text-center">
                            {{ $t("navigations.edit") }}
                          </th>
                          <th class="text-center">
                            {{ $t("navigations.delete") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="option in radiooptionsarray"
                          :key="option.codevalue"
                        >
                          <td>{{ option.codevalue }}</td>
                          <td>{{ option.optionname }}</td>
                          <td class="text-center">
                            <i
                              class="fa fa-edit icon-color"
                              @click="
                                editOptionsfordropdown(
                                  option.codevalue,
                                  option.optionname
                                );
                                focusOnEdit();
                              "
                            ></i>
                          </td>
                          <td class="text-center">
                            <i
                              class="fa fa-trash icon-color"
                              @click="deleteoptions(option.codevalue)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <span class="error-message" v-if="dropdownError">{{
                      $t("navigations.please add options for the dropdown")
                    }}</span>
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      :options="commonvalidations"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @clear="clearValues"
                      @deselect="deselectedOption"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- date starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'date'"
                class="fieldentry"
              >
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.date") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="row">
                    <div class="col-lg-6">  
                  <div class="form-group">
                    <label class="mb-0" for="datetext">{{
                      $t("navigations.date label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="datetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionsdate">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsdate"
                      placeholder=""
                    />
                  </div>

                  <div class="form-group mb-0 textgroup">
                    <label class="mb-0">{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      :options="generaldateOptions"
                      @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                    </div>
                          <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                    </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup"
                        v-if="
                          validation && validation.condition == 'DATEFORMAT'
                        "
                      >
                        <label for="instructionsdate">{{
                          $t("navigations.date format")
                        }}</label>
                        <div class="input-group">
                          <div class="col-12 px-0">
                            <select class="form-select" v-model="dateFormat">
                              <option
                                v-for="date in dateList"
                                :key="date.dateFormat"
                                :value="date.dateFormat"
                              >
                                {{ date.dateFormat }}
                              </option>
                            </select>
                          </div>
                          <div class="errormsg" v-if="daterangeErrors[3]">
                            {{ $t("navigations.please select a date format") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="validation && validation.condition == 'DATERANGE'"
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min date") }}</label>
                          <input
                            v-model="minDate"
                            :disabled="isformlocked == true"
                            type="date"
                            class="form-control"
                          />
                          <span
                            v-if="daterangeErrors[0] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max date") }}</label>
                          <input
                            v-model="maxDate"
                            :disabled="isformlocked == true"
                            type="date"
                            class="form-control"
                          />
                          <span
                            v-if="daterangeErrors[1] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div>
                          <span class="errormsg" v-if="daterangeErrors[2]">{{
                            $t(
                              "navigations.value entered on min value must be lower than value entered on max value field"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- time starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'time'"
                class="fieldentry"
              >
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.time") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                   <div class="row">
                  <div class="col-lg-6">  
                  <div class="form-group">
                    <label class="mb-0" for="timetext">{{
                      $t("navigations.time label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="timetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionstime">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionstime"
                      placeholder=""
                    />
                  </div>

                  <div class="form-group mb-0 textgroup">
                    <label class="mb-0">{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generaltimeOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  </div>
                              <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                        </div>

                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup"
                        v-if="
                          validation && validation.condition == 'TIMEFORMAT'
                        "
                      >
                        <label for="instructionstime">{{
                          $t("navigations.time format")
                        }}</label>
                        <select class="form-select" v-model="timeFormat">
                          <option value="hh:mm:ss tt">
                            {{ $t("navigations.12 hrs") }}
                          </option>
                          <option value="HH:mm:ss">
                            {{ $t("navigations.24 hrs") }}
                          </option>
                        </select>
                        <span class="errormsg" v-if="timerangeErrors[3]">{{
                          $t("navigations.please select a time format")
                        }}</span>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="validation && validation.condition == 'TIMERANGE'"
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min time") }}</label>
                          <input
                            v-model="minTime"
                            :disabled="isformlocked == true"
                            type="time"
                            class="form-control"
                            step="1"
                          />
                          <span
                            v-if="timerangeErrors[0] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max time") }}</label>
                          <input
                            v-model="maxTime"
                            :disabled="isformlocked == true"
                            type="time"
                            class="form-control"
                            step="1"
                          />
                          <span
                            v-if="timerangeErrors[1] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div>
                          <span class="errormsg" v-if="timerangeErrors[2]">{{
                            $t(
                              "navigations.value entered on min value must be lower than value entered on max value field"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- number and date starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'numberanddate'"
                class="fieldentry"
              >
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.number and date") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                    <div class="row">
                   <div class="col-lg-6">
                  <div class="form-group">
                    <label class="mb-0" for="numberanddatetext">{{
                      $t("navigations.number and date label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="numberanddatetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionsnumberanddate">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsnumberanddate"
                      placeholder=""
                    />
                  </div>

                  <div class="form-group mb-0 textgroup">
                    <label class="mb-0">{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generalnumberanddateOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  </div>
                              <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                          </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="
                          validation && validation.condition == 'NUMERICRANGE'
                        "
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min number") }}</label>
                          <input
                            v-model="minvalue"
                            :disabled="isformlocked == true"
                            min="0"
                            type="number"
                            class="form-control"
                          />
                          <span v-if="rangeErrors[2] == true" class="errormsg">
                            {{ $t("navigations.please enter a value") }}</span
                          >
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max number") }}</label>
                          <input
                            v-model="maxvalue"
                            :disabled="isformlocked == true"
                            min="0"
                            type="number"
                            class="form-control"
                          />
                          <span v-if="rangeErrors[3] == true" class="errormsg">
                            {{ $t("navigations.please enter a value") }}</span
                          >
                        </div>
                        <div>
                          <span class="errormsg" v-if="rangeErrors[6]">{{
                            $t(
                              "navigations.value entered on min value must be lower than value entered on max value field"
                            )
                          }}</span>
                          <span class="errormsg" v-if="rangeErrors[7]"
                            >{{
                              $t(
                                "navigations.value entered on max value cannot be zero"
                              )
                            }}"</span
                          >
                        </div>
                      </div>
                      <div
                        class="textgroup"
                        v-if="
                          values.length != 0 &&
                          (validation.condition == 'lengthrange' ||
                            validation.condition == 'LENGTHRANGE' ||
                            validation.condition == 'CHARACTERLIMITRANGE')
                        "
                      >
                        <div class="optgroup">
                          <div>
                            <label>{{ $t("navigations.min length") }}</label>
                            <input
                              v-model="minlength"
                              min="0"
                              type="number"
                              class="form-control"
                            />
                            <span v-if="rangeErrors[0] == true" class="errormsg"
                              >{{ $t("navigations.please enter a value") }}
                            </span>
                          </div>
                          <div>
                            <label>{{ $t("navigations.max length") }}</label>
                            <input
                              v-model="maxlength"
                              min="0"
                              type="number"
                              class="form-control"
                            />
                            <span v-if="rangeErrors[1] == true" class="errormsg"
                              >{{ $t("navigations.please enter a value") }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup"
                        v-if="
                          validation && validation.condition == 'DATEFORMAT'
                        "
                      >
                        <label for="instructionsdate">{{
                          $t("navigations.date format")
                        }}</label>
                        <div class="input-group">
                          <div class="col-12 px-0">
                            <select class="form-select" v-model="dateFormat">
                              <option
                                v-for="date in dateList"
                                :key="date.dateFormat"
                                :value="date.dateFormat"
                              >
                                {{ date.dateFormat }}
                              </option>
                            </select>
                          </div>
                          <div class="errormsg" v-if="daterangeErrors[3]">
                            {{ $t("navigations.please select a date format") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="validation && validation.condition == 'DATERANGE'"
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min date") }}</label>
                          <input
                            v-model="minDate"
                            :disabled="isformlocked == true"
                            type="date"
                            class="form-control"
                          />
                          <span
                            v-if="daterangeErrors[0] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max date") }}</label>
                          <input
                            v-model="maxDate"
                            :disabled="isformlocked == true"
                            type="date"
                            class="form-control"
                          />
                          <span
                            v-if="daterangeErrors[1] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div>
                          <span class="errormsg" v-if="daterangeErrors[2]">{{
                            $t(
                              "navigations.value entered on min value must be lower than value entered on max value field"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- radiobutton starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'radio'"
                class="fieldentry"
              >
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.radio") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="row">
                  <div class="col-lg-6">  
                  <div class="form-group row">
                    <div class="col-lg-6">
                     <label class="mb-0">
            Radio Label
            <i
              v-if="hasComments(radioField)"
              class="fa fa-comment text-info cursor-pointer ms-2"
              @click.stop="togglePopover(radioField, $event)"
            ></i>
          </label>
                      <input
                        type="text"
                        v-model="labeltext"
                        class="form-control"
                        id="radiotext"
                        placeholder=""
                      />
                    </div>
                    <div class="col-lg-6">
                      <label class="mb-0" for="dropdowntext">{{
                        $t("navigations.select option group")
                      }}</label>
                      <select
                        class="form-select select-padding horizondalscroll"
                        id="exampleFormControlSelect2"
                        v-model="selectedmodel"
                        @change.prevent="dropdownmodelchange()"
                      >
                        <option value="" disabled selected>
                          {{ $t("navigations.select") }}
                        </option>
                        <option
                          v-for="models in optiongroups.results"
                          :value="models"
                          :key="models.id"
                        >
                          {{ models.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionsradio">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsradio"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0">{{ $t("navigations.alignment") }}</label>
                    <select
                      v-model="radioorientation"
                      @change="handleChange"
                      class="form-control"
                      aria-label="Default select example"
                    >
                      <option value="horizontal">Horizontal</option>
                      <option value="vertical">Vertical</option>
                    </select>
                  </div>
                  </div>
                  <div class="col-lg-6"> 
                          <div class="col-md-12 px-0">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                    
                     </div>
                  </div>
                  <div class="form-group textgroup">
                    <div class="row mb-3 pr-3 d-flex align-items-center">
                      <div class="col-lg-2 pr-0">
                        <label class="mt-3 mb-0" for="optionscheckbox">{{$t("navigations.add options")}} : </label>
                      </div>
                      <div class="col-lg-5 pr-0">
                        <label class="mb-0">{{$t("navigations.code value")}}</label>
                        <input
                          ref="codeValueInput"
                          type="text"
                          class="form-control"
                          v-model="radiovalues"
                          maxlength="50"
                        />
                      </div>

                      <div class="col-lg-5 pr-0">
                        <label class="mb-0">{{
                          $t("navigations.option name")
                        }}</label>
                        <input
                          type="text"
                          ref="optionNameInput"
                          class="form-control"
                          v-model="radiooptions"
                          id="optionscheckbox"
                          maxlength="50"
                        />
                      </div>
                      
                    </div>

                    <div class="row">
                      <div class="col-lg-12">
                        <!-- Add button  -->
                        <div class="d-flex justify-content-end">
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="addradiooptions()"
                            v-if="editingOption === null"
                            :disabled="
                              radiovalues == '' ||
                              radiovalues == null ||
                              radiooptions == '' ||
                              radiooptions == null
                            "
                          >
                            {{ $t("navigations.add") }}
                          </button>
                          <!-- Update button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="UpdateDropdownoptions()"
                            v-else
                          >
                            {{ $t("navigations.update") }}
                          </button>
                          <div style="margin-left: 10px"></div>
                          <!-- Cancel button -->
                          <button
                            type="button"
                            class="save_btn px-3 py-1"
                            @click.prevent="cancelEditDropdown()"
                            v-if="editingOption !== null"
                            style="background-color: red; color: white"
                          >
                            {{ $t("navigations.cancel") }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group textgroup"
                      style="overflow-y: auto; max-height: 250px"
                    >
                      <!-- <label for="optionslistcheckbox">Options</label> -->
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>{{ $t("navigations.code value") }}</th>
                            <th>{{ $t("navigations.option name") }}</th>
                            <th class="text-center">
                              {{ $t("navigations.edit") }}
                            </th>
                            <th class="text-center">
                              {{ $t("navigations.delete") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="option in radiooptionsarray"
                            :key="option.codevalue"
                          >
                            <td>{{ option.codevalue }}</td>
                            <td>{{ option.optionname }}</td>
                            <td class="text-center">
                              <i
                                class="fa fa-edit icon-color"
                                @click="
                                  editOptionsfordropdown(
                                    option.codevalue,
                                    option.optionname
                                  );
                                  focusOnEdit();
                                "
                              ></i>
                            </td>
                            <td class="text-center">
                              <i
                                class="fa fa-trash icon-color"
                                @click="deleteoptions(option.codevalue)"
                              ></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <span class="error-message" v-if="dropdownError">{{
                        $t("navigations.please add options for the radio")
                      }}</span>
                    </div>
                    <div class="form-group mb-0 textgroup">
                      <label>{{ $t("navigations.validations") }}</label>
                      <Multiselect
                        :disabled="isformlocked == true"
                        class="multiselect-theme"
                        mode="multiple"
                        v-model="values"
                        @change="valuesChanged()"
                        @clear="clearValues"
                        @select="changeArray"
                        @deselect="deselectedOption"
                        :options="commonvalidations"
                        :hideSelected="false"
                        :closeOnSelect="false"
                        :placeholder="$t('navigations.select validations')"
                      />
                    </div>
                    <div
                      class="form-group col-12 px-0 my-2"
                      v-if="generalValidations.length > 0"
                    >
                      <div
                        class="ibox-content p-3 mb-2"
                        v-for="(validation, index) in generalValidations"
                        :key="index"
                      >
                        <div class="d-flex justify-content-between">
                          <label
                            >Validation for
                            <b>{{ validation.condition }}</b></label
                          >
                          <div
                            class="position-relative cursor-pointer"
                            v-if="isformlocked == false"
                            @click.prevent="deleteMessage('general', index)"
                          >
                            <img
                              width="17"
                              src="../../assets/delete_doc.png"
                              alt="delete message"
                            />
                            <div class="tool-tip">
                              {{ $t("navigations.delete validation") }}
                            </div>
                          </div>
                        </div>
                        <div>
                          <label :for="`optionRadiosExclusion${index}`"
                            ><input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked == true"
                              :value="`Exclusion`"
                              :id="`optionRadiosExclusion${index}`"
                            /><span class="mr-1">{{
                              $t(
                                "navigations.exclusion(blocks further data entry)"
                              )
                            }}</span></label
                          ><img
                            class="mb-1"
                            src="../../assets/img/exclusion.png"
                          />
                        </div>
                        <div>
                          <label :for="`optionRadiosError${index}`"
                            ><input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked == true"
                              :value="`Alert`"
                              :id="`optionRadiosError${index}`"
                            /><span class="mr-1">{{
                              $t(
                                "navigations.error(prevents saving that field value)"
                              )
                            }}</span></label
                          ><img class="mb-1" src="../../assets/img/alert.png" />
                        </div>
                        <div>
                          <label :for="`optionRadiosWarning${index}`"
                            ><input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked == true"
                              :value="`Warning`"
                              :id="`optionRadiosWarning${index}`"
                            /><span class="mr-1">{{
                              $t("navigations.warning")
                            }}</span></label
                          ><img
                            class="mb-1"
                            src="../../assets/img/warning.png"
                          />
                        </div>
                        <div>
                          <label :for="`optionRadiosInformation${index}`"
                            ><input
                              class="mr-1"
                              type="radio"
                              v-model="validation.messageType"
                              :disabled="isformlocked == true"
                              :value="`Information`"
                              :id="`optionRadiosInformation${index}`"
                            /><span class="mr-1">{{
                              $t("navigations.information")
                            }}</span></label
                          ><img class="mb-1" src="../../assets/img/info.png" />
                        </div>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][0] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please choose a value") }}
                        </div>
                        <div class="col-12 px-0">
                          <label for="message">{{
                            $t("navigations.message")
                          }}</label>
                          <textarea
                            class="form-control"
                            v-model="validation.message"
                            :disabled="isformlocked == true"
                            placeholder="Message"
                            id="message"
                            minlength="10"
                            spellcheck="true"
                          ></textarea>
                          <div
                            v-if="
                              generalValidationsError &&
                              generalValidationsError[index] &&
                              generalValidationsError[index][1] == true
                            "
                            class="errormsg py-1 mx-0"
                          >
                            {{ $t("navigations.please enter a value") }}
                          </div>
                        </div>
                      </div>
                      <div class="px-0">
                        <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <!-- year starts  -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'year'"
                class="fieldentry"
              >
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.year") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                    <div class="row">
                   <div class="col-lg-6">
                  <div class="form-group">
                    <label class="mb-0" for="yeartext">{{
                      $t("navigations.year label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="yeartext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionsyear">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionsyear"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label class="mb-0">{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generalyearOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  </div>
                          <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                    
                     </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="validation && validation.condition == 'YEARRANGE'"
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min year") }}</label>
                          <input
                            type="number"
                            min="1900"
                            max="2024"
                            v-model="minYear"
                            @keydown="preventNonNumericKeys"
                            class="form-control"
                            @input="validateMinYear"
                          />
                          <span
                            v-if="yearrangeError[0] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max year") }}</label>
                          <input
                            type="number"
                            min="1900"
                            max="2024"
                            @keydown="preventNonNumericKeys"
                            v-model="maxYear"
                            class="form-control"
                            @input="validateMaxYear"
                          />
                          <span
                            v-if="yearrangeError[1] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div>
                          <span class="errormsg" v-if="yearrangeError[2]">{{
                            $t(
                              "navigations.value entered on min year must be lower than value entered on max year field"
                            )
                          }}</span>
                          <span class="errormsg" v-if="yearrangeError[3]">{{
                            $t(
                              "navigations.value entered on max year cannot be zero"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- dateandtime starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'dateandtime'"
                class="fieldentry"
              >
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.date and time") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="form-group">
                    <label for="timetext">{{
                      $t("navigations.date and time label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="timetext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label for="instructionstime">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstime"
                      placeholder=""
                    />
                  </div>

                  <div class="form-group mb-0 textgroup">
                    <label>{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      @clear="clearValues"
                      :options="generaldateandtimeOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup"
                        v-if="
                          validation && validation.condition == 'DATEFORMAT'
                        "
                      >
                        <label for="instructionsdate">{{
                          $t("navigations.date format")
                        }}</label>
                        <div class="input-group">
                          <div class="col-12 px-0">
                            <select class="form-select" v-model="dateFormat">
                              <option
                                v-for="date in dateList"
                                :key="date.dateFormat"
                                :value="date.dateFormat"
                              >
                                {{ date.dateFormat }}
                              </option>
                            </select>
                          </div>
                          <div class="errormsg" v-if="daterangeErrors[3]">
                            {{ $t("navigations.please select a date format") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="validation && validation.condition == 'DATERANGE'"
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min date") }}</label>
                          <input
                            v-model="minDate"
                            :disabled="isformlocked == true"
                            type="date"
                            class="form-control"
                          />
                          <span
                            v-if="daterangeErrors[0] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max date") }}</label>
                          <input
                            v-model="maxDate"
                            :disabled="isformlocked == true"
                            type="date"
                            class="form-control"
                          />
                          <span
                            v-if="daterangeErrors[1] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div>
                          <span class="errormsg" v-if="daterangeErrors[2]">{{
                            $t(
                              "navigations.value entered on min value must be lower than value entered on max value field"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="form-group textgroup"
                        v-if="
                          validation && validation.condition == 'TIMEFORMAT'
                        "
                      >
                        <label for="instructionstime">{{
                          $t("navigations.time format")
                        }}</label>
                        <select
                          :disabled="isformlocked == true"
                          class="form-select"
                          v-model="timeFormat"
                        >
                          <option value="hh:mm:ss tt">
                            {{ $t("navigations.12 hrs") }}
                          </option>
                          <option value="HH:mm:ss">
                            {{ $t("navigations.24 hrs") }}
                          </option>
                        </select>
                        <span class="errormsg" v-if="timerangeErrors[3]">{{
                          $t("navigations.please select a time format")
                        }}</span>
                      </div>
                      <div
                        class="form-group textgroup row"
                        v-if="validation && validation.condition == 'TIMERANGE'"
                      >
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.min time") }}</label>
                          <input
                            v-model="minTime"
                            :disabled="isformlocked == true"
                            type="time"
                            step="1"
                            class="form-control"
                          />
                          <span
                            v-if="timerangeErrors[0] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div class="col-12 col-md-6">
                          <label>{{ $t("navigations.max time") }}</label>
                          <input
                            v-model="maxTime"
                            :disabled="isformlocked == true"
                            type="time"
                            step="1"
                            class="form-control"
                          />
                          <span
                            v-if="timerangeErrors[1] == true"
                            class="errormsg"
                            >{{ $t("navigations.please enter a value") }}
                          </span>
                        </div>
                        <div>
                          <span class="errormsg" v-if="timerangeErrors[2]">{{
                            $t(
                              "navigations.value entered on min value must be lower than value entered on max value field"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- checkbox starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'checkbox'"
                class="fieldentry"
              >
                <!-- <div class="ibox-title">
                  <h5>{{ $t("navigations.checkbox") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                  <div class="row">
                  <div class="col-lg-6">  
                  <div class="form-group">
                    <label class="mb-0" for="checkboxtext">{{
                      $t("navigations.checkbox label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="checkboxtext"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionscheckbox">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      class="form-control"
                      id="instructionscheckbox"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group mb-0 textgroup">
                    <label class="mb-0">{{ $t("navigations.validations") }}</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @clear="clearValues"
                      @change="valuesChanged()"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="commonvalidations"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                  </div>
                             <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                      </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- textarea starts -->
              <div
                v-if="refreshFlags.general && selectedmenu == 'textarea'"
                class="fieldentry"
              >
                <!-- <div class="ibox-modal-title">
                  <h5>{{ $t("navigations.textarea") }}</h5>
                </div> -->
                <div class="ibox-content-edit">
                    <div class="row">
                   <div class="col-lg-6">
                  <div class="form-group">
                    <label class="mb-0" for="textareatext">{{
                      $t("navigations.textarea label")
                    }}</label>
                    <input
                      type="text"
                      v-model="labeltext"
                      class="form-control"
                      id="textareatext"
                      placeholder=""
                      :disabled="isformlocked == true"
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0" for="instructionstextarea">{{
                      $t("navigations.field name")
                    }}</label>
                    <input
                      type="text"
                      v-model="fieldname"
                      maxlength="30"
                      class="form-control"
                      id="instructionstextarea"
                      placeholder=""
                      :disabled="isformlocked == true"
                    />
                  </div>
                  <div class="form-group textgroup">
                    <label class="mb-0">Validations</label>
                    <Multiselect
                      :disabled="isformlocked == true"
                      class="multiselect-theme"
                      mode="multiple"
                      v-model="values"
                      @change="valuesChanged()"
                      @clear="clearValues"
                      @select="changeArray"
                      @deselect="deselectedOption"
                      :options="generaltextareaOptions"
                      :hideSelected="false"
                      :closeOnSelect="false"
                      :placeholder="$t('navigations.select validations')"
                    />
                  </div>
                   </div>
                           <div class="col-md-6">
                      <label class="mb-0">Comments</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        rows="7"
                        v-model="comments"
                        :disabled="isformlocked"
                      >
                      </textarea>
                    </div>
                      </div>
                  <div
                    class="form-group col-12 px-0 my-2"
                    v-if="generalValidations.length > 0"
                  >
                    <div
                      class="ibox-content p-3 mb-2"
                      v-for="(validation, index) in generalValidations"
                      :key="index"
                    >
                      <div class="d-flex justify-content-between">
                        <label
                          >Validation for
                          <b>{{ validation.condition }}</b></label
                        >
                        <div
                          class="position-relative cursor-pointer"
                          v-if="isformlocked == false"
                          @click.prevent="deleteMessage('general', index)"
                        >
                          <img
                            width="17"
                            src="../../assets/delete_doc.png"
                            alt="delete message"
                          />
                          <div class="tool-tip">
                            {{ $t("navigations.delete validation") }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="textgroup mb-2"
                        v-if="
                          (validation &&
                            (validation.condition == 'lengthrange' ||
                              validation.condition == 'LENGTHRANGE')) ||
                          validation.condition == 'CHARACTERLIMITRANGE'
                        "
                      >
                        <div class="optgroup">
                          <div>
                            <label>{{ $t("navigations.min length") }}</label>
                            <input
                              v-model="minlength"
                              min="0"
                              type="number"
                              class="form-control"
                            />
                            <span v-if="rangeErrors[0] == true" class="errormsg"
                              >{{ $t("navigations.please enter a value") }}
                            </span>
                          </div>
                          <div>
                            <label>{{ $t("navigations.max length") }}</label>
                            <input
                              v-model="maxlength"
                              min="0"
                              type="number"
                              class="form-control"
                            />
                            <span v-if="rangeErrors[1] == true" class="errormsg"
                              >{{ $t("navigations.please enter a value") }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <span class="errormsg" v-if="rangeErrors[4]">{{
                            $t(
                              "navigations.value entered on min length must be lower than value               entered on max length field"
                            )
                          }}</span>
                          <span class="errormsg" v-if="rangeErrors[5]">{{
                            $t(
                              "navigations.value entered on max length cannot be zero"
                            )
                          }}</span>
                        </div>
                      </div>
                      <div>
                        <label :for="`optionRadiosExclusion${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Exclusion`"
                            :id="`optionRadiosExclusion${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.exclusion(blocks further data entry)"
                            )
                          }}</span></label
                        ><img
                          class="mb-1"
                          src="../../assets/img/exclusion.png"
                        />
                      </div>
                      <div>
                        <label :for="`optionRadiosError${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Alert`"
                            :id="`optionRadiosError${index}`"
                          /><span class="mr-1">{{
                            $t(
                              "navigations.error(prevents saving that field value)"
                            )
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/alert.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosWarning${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Warning`"
                            :id="`optionRadiosWarning${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.warning")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/warning.png" />
                      </div>
                      <div>
                        <label :for="`optionRadiosInformation${index}`"
                          ><input
                            class="mr-1"
                            type="radio"
                            v-model="validation.messageType"
                            :disabled="isformlocked == true"
                            :value="`Information`"
                            :id="`optionRadiosInformation${index}`"
                          /><span class="mr-1">{{
                            $t("navigations.information")
                          }}</span></label
                        ><img class="mb-1" src="../../assets/img/info.png" />
                      </div>
                      <div
                        v-if="
                          generalValidationsError &&
                          generalValidationsError[index] &&
                          generalValidationsError[index][0] == true
                        "
                        class="errormsg py-1 mx-0"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                      <div class="col-12 px-0">
                        <label for="message">{{
                          $t("navigations.message")
                        }}</label>
                        <textarea
                          class="form-control"
                          v-model="validation.message"
                          :disabled="isformlocked == true"
                          placeholder="Message"
                          id="message"
                          minlength="10"
                          spellcheck="true"
                        ></textarea>
                        <div
                          v-if="
                            generalValidationsError &&
                            generalValidationsError[index] &&
                            generalValidationsError[index][1] == true
                          "
                          class="errormsg py-1 mx-0"
                        >
                          {{ $t("navigations.please enter a value") }}
                        </div>
                      </div>
                    </div>
                    <div class="px-0">
                      <!-- <button type="button" @click.prevent="addValidation('general')" class="btn-outline btn-default btn-dark-round-outline px-3 py-1"> + {{ $t('navigations.add validation') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- ============ VALIDATION ============ -->
              <div role="tabpanel" v-if="refreshFlags.validation">
                <div
                  class="row mt-5 text-center"
                  v-if="isformlocked && exclusionMessages.length === 0"
                >
                  <h5>{{ $t("navigations.no validations added") }}</h5>
                </div>

                <div
                  v-for="(messages, index) in exclusionMessages"
                  :key="'ex-' + index"
                >
                  <div
                    class="d-flex justify-content-between align-items-center mb-4"
                  >
                    <h5 class="mb-0">
                      {{ $t("navigations.validation message") }}
                    </h5>
                    <div
                      class="position-relative cursor-pointer"
                      v-if="!isformlocked"
                      @click.prevent="deleteMessage('custom', index)"
                    >
                      <img
                        width="17"
                        src="../../assets/delete_doc.png"
                        alt="delete message"
                      />
                      <div class="tool-tip">
                        {{ $t("navigations.delete validation") }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="row mx-0"
                    :class="{ 'mb-2': exclusionMessages.length > 1 }"
                  >
                    <div
                      class="form-group col-12 col-md-6 pl-0 pr-1"
                      v-if="
                        inputValidationElements.indexOf(selectedmenu) !== -1
                      "
                    >
                      <label for="fieldSelect">{{
                        $t("navigations.if the field is")
                      }}</label>
                      <select
                        :disabled="isformlocked"
                        v-model="messages.value[0]"
                        id="fieldValue"
                        class="form-select"
                      >
                        <option
                          v-for="option in radiooptionsarray"
                          :key="'opt-' + option.codevalue"
                          :value="option.codevalue"
                        >
                          {{ option.optionname }}
                        </option>
                      </select>
                      <div
                        v-if="
                          exclusionMessagesError[index] &&
                          exclusionMessagesError[index][0]
                        "
                        class="errormsg"
                      >
                        {{ $t("navigations.please enter a value") }}
                      </div>
                    </div>

                    <div
                      class="form-group col-12 col-md-6 pl-1 pr-0"
                      v-if="
                        inputValidationElements.indexOf(selectedmenu) !== -1
                      "
                    >
                      <label
                        v-if="selectedmenu !== 'checkbox'"
                        for="fieldValue"
                        >{{ $t("navigations.value is") }}</label
                      >

                      <template v-if="selectedmenu === 'year'">
                        <input
                          :disabled="isformlocked"
                          type="number"
                          @keydown="preventNonNumericKeys"
                          @input="validateYearInput(messages.value[0], index)"
                          v-model="messages.value[0]"
                          class="form-control"
                          id="fieldValue"
                          min="1000"
                          max="2100"
                          step="1"
                        />
                      </template>
                      <template v-else-if="selectedmenu === 'date'">
                        <input
                          :disabled="isformlocked"
                          type="date"
                          v-model="messages.value[0]"
                          id="fieldValue"
                          class="form-control"
                        />
                      </template>
                      <template
                        v-else-if="
                          selectedmenu === 'radio' ||
                          selectedmenu === 'dropdown'
                        "
                      >
                        <select
                          :disabled="isformlocked"
                          v-model="messages.value[0]"
                          id="fieldValue"
                          class="form-select"
                        >
                          <option
                            v-for="option in radiooptionsarray"
                            :key="'opt-' + option.codevalue"
                            :value="option.codevalue"
                          >
                            {{ option.optionname }}
                          </option>
                        </select>
                      </template>
                      <template v-else>
                        <input
                          :disabled="isformlocked"
                          type="text"
                          v-model="messages.value[0]"
                          id="fieldValue"
                          class="form-control"
                        />
                      </template>

                      <div
                        v-if="
                          exclusionMessagesError[index] &&
                          exclusionMessagesError[index][3]
                        "
                        class="errormsg mx-0 py-1"
                      >
                        {{ $t("navigations.please enter a value") }}
                      </div>
                    </div>

                    <div class="form-group col-12 px-0">
                      <div>
                        <label>{{ $t("navigations.show") }}</label>
                        <div>
                          <label :for="'optionRadiosExclusion2' + index">
                            <input
                              :disabled="isformlocked"
                              class="mr-1"
                              type="radio"
                              v-model="messages.messageType"
                              value="Exclusion"
                              :id="'optionRadiosExclusion2' + index"
                            />
                            <span class="mr-1">{{
                              $t(
                                "navigations.exclusion(blocks further data entry)"
                              )
                            }}</span>
                          </label>
                          <img
                            class="mb-1"
                            src="../../assets/img/exclusion.png"
                          />
                        </div>
                        <div>
                          <label :for="'optionRadiosError2' + index">
                            <input
                              :disabled="isformlocked"
                              class="mr-1"
                              type="radio"
                              v-model="messages.messageType"
                              value="Alert"
                              :id="'optionRadiosError2' + index"
                            />
                            <span class="mr-1">{{
                              $t(
                                "navigations.error(prevents saving that field value)"
                              )
                            }}</span>
                          </label>
                          <img class="mb-1" src="../../assets/img/alert.png" />
                        </div>
                        <div>
                          <label :for="'optionRadiosWarning2' + index">
                            <input
                              :disabled="isformlocked"
                              class="mr-1"
                              type="radio"
                              v-model="messages.messageType"
                              value="Warning"
                              :id="'optionRadiosWarning2' + index"
                            />
                            <span class="mr-1">{{
                              $t("navigations.warning")
                            }}</span>
                          </label>
                          <img
                            class="mb-1"
                            src="../../assets/img/warning.png"
                          />
                        </div>
                        <div>
                          <label :for="'optionRadiosInformation2' + index">
                            <input
                              :disabled="isformlocked"
                              class="mr-1"
                              type="radio"
                              v-model="messages.messageType"
                              value="Information"
                              :id="'optionRadiosInformation2' + index"
                            />
                            <span class="mr-1">{{
                              $t("navigations.information")
                            }}</span>
                          </label>
                          <img class="mb-1" src="../../assets/img/info.png" />
                        </div>
                      </div>
                      <div
                        v-if="
                          exclusionMessagesError[index] &&
                          exclusionMessagesError[index][1]
                        "
                        class="errormsg mx-0 py-1"
                      >
                        {{ $t("navigations.please choose a value") }}
                      </div>
                    </div>

                    <div class="form-group col-12 px-0">
                      <label for="message2">{{
                        $t("navigations.message")
                      }}</label>
                      <textarea
                        :disabled="isformlocked"
                        class="form-control"
                        v-model="messages.message"
                        id="message2"
                        minlength="10"
                        spellcheck="true"
                      ></textarea>
                      <div
                        v-if="
                          exclusionMessagesError[index] &&
                          exclusionMessagesError[index][2]
                        "
                        class="errormsg mx-0 py-1"
                      >
                        {{ $t("navigations.please enter a value") }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="px-0" v-if="!isformlocked">
                  <button
                    type="button"
                    @click.prevent="addValidation('custom')"
                    class="btn-outline btn-default btn-dark-round-outline px-3 py-1"
                  >
                    + {{ $t("navigations.add validation") }}
                  </button>
                </div>
              </div>

              <!-- ============ DEPENDENCIES ============ -->
              <div role="tabpanel" v-if="refreshFlags.dependencies">
                <div class="mb-2">
                  <label class="me-3">
                    <input type="radio" value="no" v-model="selectedOption" />
                    {{ "No dependency" }}
                  </label>
                  <label>
                    <input type="radio" value="yes" v-model="selectedOption" />
                    {{ "Add dependency" }}
                  </label>
                </div>

                <div v-if="selectedOption === 'yes'">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h6 class="mb-0">{{ "Dependencies" }}</h6>
                    <button
                      class="btn btn-sm btn-outline-primary"
                      @click="addValidation('dependencies')"
                    >
                      {{ $t("navigations.add") || "Add" }}
                    </button>
                  </div>

                  <div
                    v-for="(dep, i) in dependencies"
                    :key="'dep-' + i"
                    class="card p-2 mt-2"
                  >
                    <div class="row g-2">
                      <div class="col-md-4">
                        <label class="mb-1">{{
                          $t("navigations.form") || "Form"
                        }}</label>
                        <select
                          class="form-select"
                          v-model="dep.targetTemplateId"
                          @change="
                            getFields(
                              dep.targetTemplateId &&
                                dep.targetTemplateId.templateId
                                ? dep.targetTemplateId.templateId
                                : '',
                              dep.targetTemplateId &&
                                dep.targetTemplateId.version
                                ? dep.targetTemplateId.version
                                : '',
                              i
                            )
                          "
                        >
                          <option :value="null" disabled>
                            {{ $t("navigations.select") || "Select" }}
                          </option>
                          <option
                            v-for="f in formList"
                            :key="f.templateId"
                            :value="f"
                          >
                            {{ f.templateName }} (v{{ f.version }})
                          </option>
                        </select>
                      </div>

                      <div class="col-md-4">
                        <label class="mb-1">{{
                          $t("navigations.field") || "Field"
                        }}</label>
                        <select
                          class="form-select"
                          v-model="dep.visibilityfieldname"
                        >
                          <option :value="null" disabled>
                            {{ $t("navigations.select") || "Select" }}
                          </option>
                          <option
                            v-for="fn in fieldNames[i] || []"
                            :key="fn.fieldName"
                            :value="fn"
                          >
                            {{ fn.fieldName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-4">
                        <label class="mb-1">{{
                          $t("navigations.condition") || "Condition"
                        }}</label>
                        <select class="form-select" v-model="dep.condition">
                          <option
                            v-for="c in selectedConditionsArray"
                            :key="c.value"
                            :value="c.value"
                          >
                            {{ c.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row g-2 mt-1">
                      <div class="col-md-6">
                        <label class="mb-1">{{
                          $t("navigations.value") || "Value"
                        }}</label>
                        <template
                          v-if="
                            selectedmenu === 'radio' ||
                            selectedmenu === 'dropdown' ||
                            selectedmenu === 'radiohorizondal'
                          "
                        >
                          <select class="form-select" v-model="dep.value">
                            <option
                              v-for="opt in radiooptionsarray"
                              :key="opt.codevalue"
                              :value="opt.optionname"
                            >
                              {{ opt.optionname }}
                            </option>
                          </select>
                        </template>
                        <template v-else>
                          <input class="form-control" v-model="dep.value" />
                        </template>
                      </div>

                      <div class="col-md-6 d-flex align-items-end">
                        <div class="form-check">
                          <input
                            :id="'vis-' + i"
                            class="form-check-input"
                            type="checkbox"
                            v-model="dep.isVisible"
                          />
                          <label class="form-check-label" :for="'vis-' + i">
                            {{ "Visible when true" }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="text-end mt-2">
                      <button
                        class="btn btn-sm btn-outline-danger"
                        @click="deleteMessage('dependencies', i)"
                      >
                        {{ $t("navigations.delete") || "Delete" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ============ CALCULATIONS (TAB) ============ -->
              <div role="tabpanel" v-if="refreshFlags.calculations">
                <div
                  class="row mt-5 text-center"
                  v-if="isformlocked && calculationsArray.length === 0"
                >
                  <h5>{{ $t("navigations.no calculations added") }}</h5>
                </div>

                <div
                  class="ibox-content px-3 py-1 mb-2"
                  v-for="(calc, index) in calculationsArray"
                  :key="'calc-' + index"
                >
                  <div class="d-flex justify-content-end mb-2">
                    <div
                      v-if="!isformlocked"
                      class="position-relative cursor-pointer"
                      @click.prevent="deleteMessage('calculations', index)"
                    >
                      <img
                        width="17"
                        src="../../assets/delete_doc.png"
                        alt="delete message"
                      />
                      <div class="tool-tip">
                        {{ $t("navigations.delete calculations") }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-12 pl-0 pr-1">
                    <div
                      class="d-flex justify-content-between align-items-center mb-2"
                    >
                      <label class="mb-0" for="fieldSelectCalc">{{
                        $t("navigations.form")
                      }}</label>
                    </div>
                    <select
                      :disabled="isformlocked"
                      id="fieldSelectCalc"
                      v-model="calculationTemplateId[index]"
                      @change.prevent="
                        getCalculationFields(
                          calculationTemplateId[index].templateId,
                          calculationTemplateId[index].version,
                          index
                        )
                      "
                      class="study-select select-padding"
                    >
                      <option
                        v-for="form in formList"
                        :key="'f-' + form.templateId"
                        :value="form"
                      >
                        {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                      </option>
                    </select>
                    <div
                      v-if="
                        dependencyMessagesError[index] &&
                        dependencyMessagesError[index][0]
                      "
                      class="errormsg mx-0 py-1"
                    >
                      {{ $t("navigations.please choose a value") }}
                    </div>
                  </div>

                  <textarea
                    :disabled="isformlocked"
                    class="form-control mb-1"
                    :id="'calculationField-' + index"
                    v-model="calc.expression"
                    @input="handleInput($event, calc.expression, index)"
                    @keydown="handleKeydown"
                    placeholder="Use @ to select a fieldname."
                    minlength="10"
                  ></textarea>
                  <div
                    v-if="
                      calculationMessagesError[index] &&
                      calculationMessagesError[index][0]
                    "
                    class="errormsg mx-0"
                  >
                    {{ $t("navigations.please enter an expression") }}
                  </div>

                  <ul v-if="showSuggestions[index]" class="suggestions">
                    <li
                      v-for="(field, fieldIndex) in filteredFields"
                      :key="'sug-' + fieldIndex"
                      @click="selectSuggestion(field, calc.expression, index)"
                    >
                      {{ field }}
                    </li>
                  </ul>

                  <div
                    class="text-right py-1"
                    v-if="showValidate[index] === true"
                  >
                    <button
                      type="button"
                      @click.prevent="inputFields(calc.expression, index)"
                      class="save_btn py-1 px-4"
                    >
                      {{ $t("navigations.validate") }}
                    </button>
                  </div>

                  <div
                    class="validation-block"
                    v-if="showValidate[index] === false"
                  >
                    <div class="form-group row">
                      <div
                        class="col-3"
                        v-for="(item, rindex) in dynamicFields[index]"
                        :key="'dyn-' + rindex"
                      >
                        <label :for="item + '-label'">{{ item }}</label>
                        <input
                          type="text"
                          class="form-control"
                          :id="item + '-label'"
                        />
                      </div>
                    </div>
                    <div class="text-right">
                      <button
                        type="button"
                        @click.prevent="inputFields(calc.expression, index)"
                        class="save_btn py-1 px-4"
                      >
                        {{ $t("navigations.validate") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="px-0" v-if="!isformlocked">
                  <button
                    type="button"
                    @click.prevent="addValidation('calculations')"
                    class="btn-outline btn-default btn-dark-round-outline px-3 py-1"
                  >
                    + {{ $t("navigations.add calculation") }}
                  </button>
                </div>
              </div>
            </div>

            <!-- FOOTER -->
            <div class="modalfooter">
              <div
                class="my-2 row"
                v-if="
                  selectedmenu !== 'repeatedmeasure' &&
                  selectedmenu !== 'repeatedmodel' &&
                  selectedmenu !== 'model'
                "
              >
                <div class="col-md-12 d-flex justify-content-end">
                  <button
                    v-if="!isformlocked"
                    type="button"
                    :disabled="loadingBlock"
                    :class="{ 'disabled-btn': loadingBlock }"
                    @click.prevent="deletecomponent()"
                    class="cancel_btn py-1 px-4 mr-2"
                  >
                    <span>{{ $t("navigations.delete") }}</span>
                  </button>
                  <button
                    type="button"
                    :disabled="loadingBlock"
                    :class="{ 'disabled-btn': loadingBlock }"
                    @click.prevent="editfield()"
                    class="save_btn py-1 px-4"
                    v-if="isedit && !isformlocked"
                  >
                    <div v-if="loadingBlock">
                      <img
                        src="../../assets/img/loading.webp"
                        width="15"
                        class="loading-btn-img"
                        alt="Waiting for login"
                      />
                    </div>
                    <div v-else>{{ $t("navigations.save") }}</div>
                  </button>
                  <button
                    type="button"
                    :disabled="loadingBlock"
                    :class="{ 'disabled-btn': loadingBlock }"
                    @click.prevent="addfield(selectedmenu)"
                    class="save_btn py-1 px-4"
                    v-if="!isedit && !isformlocked"
                  >
                    <div v-if="loadingBlock">
                      <img
                        src="../../assets/img/loading.webp"
                        width="15"
                        class="loading-btn-img"
                        alt="Waiting for login"
                      />
                    </div>
                    <div v-else>{{ $t("navigations.add") }}</div>
                  </button>
                </div>
              </div>

              <div class="my-2 row" v-if="selectedmenu === 'model'">
                <div class="col-md-12 d-flex justify-content-end">
                  <button
                    type="button"
                    :disabled="loadingBlock"
                    :class="{ 'disabled-btn': loadingBlock }"
                    @click.prevent="deletecomponent()"
                    class="cancel_btn py-1 px-4 mr-2"
                  >
                    <div v-if="loadingBlock">
                      <img
                        src="../../assets/img/loading.webp"
                        width="15"
                        class="loading-btn-img"
                        alt="Waiting for login"
                      />
                    </div>
                    <div v-else>{{ $t("navigations.delete") }}</div>
                  </button>
                  <button
                    type="button"
                    @click.prevent="addmodel()"
                    class="save_btn py-1 px-4"
                    v-if="isedit"
                  >
                    <div v-if="loadingBlock">
                      <img
                        src="../../assets/img/loading.webp"
                        width="15"
                        class="loading-btn-img"
                        alt="Waiting for login"
                      />
                    </div>
                    <div v-else>{{ $t("navigations.save") }}</div>
                  </button>
                </div>
              </div>

              <div class="my-2 row" v-if="selectedmenu === 'repeatedmeasure'">
                <div class="col-md-12 d-flex justify-content-end">
                  <button
                    type="button"
                    @click.prevent="addrepeatedmeasure()"
                    class="save_btn py-1 px-4"
                    v-if="isedit"
                  >
                    <div>{{ $t("navigations.save") }}</div>
                  </button>
                </div>
              </div>

              <div class="my-2 row" v-if="selectedmenu === 'repeatedmodel'">
                <div class="col-md-12 d-flex justify-content-end">
                  <button
                    type="button"
                    @click.prevent="addrepeatedmeasure()"
                    class="save_btn py-1 px-4"
                    v-if="isedit"
                  >
                    <span>{{ $t("navigations.save") }}</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- /FOOTER -->
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>


<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

import axios from "axios";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";
import store from "../../store/index";
import * as bootstrap from 'bootstrap';
export default {
  name: "FieldCustomizationPopup",
  components: { customModal, Multiselect },

  props: {
    // modal control
    modelValue: { type: Boolean, default: undefined },

    // incoming field (existing field object)
    value: { type: Object, default: () => ({}) },

    // positioning / context
    pageNo: { type: Number, required: true },
    indexOnPage: { type: Number, required: true },

    // identifiers and auth
    templateId: { type: String, required: true },
    authToken: { type: String, default: "" },

    // base url for API (fallback to env if present)
    baseurl: {
      type: String,
      default: () =>
        typeof process !== "undefined" &&
        process.env &&
        process.env.VUE_APP_Service_URL
          ? process.env.VUE_APP_Service_URL
          : "",
    },

    // optional ordering
    grouporderno: { type: Number, default: 0 },

    // endpoints (used for fields + calc fields)
    endpoints: {
      type: Object,
      default: () => ({
        // NOTE: formlist uses a different endpoint (see getDependencyForms)
        fields: "/forms/fields",
        calcFields: "/forms/calc-fields",
      }),
    },
  },

  emits: ["update:modelValue", "closeeditmodal", "saved", "deleted", "error"],

  data() {
    return {
      componentModal:
        typeof this.modelValue === "boolean" ? this.modelValue : true,
      idtoken: store.getters.getIdToken,

      isHydrating: false,
      showErrors: false,

      // Options for validations per field type
      commonvalidations: [],
      generaldateOptions: [],
      generaltimeOptions: [],
      generalyearOptions: [],
      generalnumberanddateOptions: [],
      generaltextareaOptions: [],
      generaldateandtimeOptions: [],

      // Core field basics
      fieldId: null,
      fieldname: "Field",
      labeltext: "",
      comments: "",
      selectedmenu: "textbox",
      isformlocked: false,
      isedit: false,
      loadingBlock: false,

      // Tabs
      refreshFlags: {
        general: true,
        validation: false,
        dependencies: false,
        calculations: false,
      },

      // Validations
      inputValidationElements: [
        "textbox",
        "text",
        "date",
        "time",
        "numberanddate",
        "year",
        "radio",
        "dropdown",
        "checkbox",
        "textarea",
      ],
      values: [],
      options: [],
      generalValidations: [],
      generalValidationsError: [],

      // Range helpers
      minlength: null,
      maxlength: null,
      minvalue: null,
      maxvalue: null,
      rangeErrors: [false, false, false, false, false, false, false, false],
      daterangeErrors: [false, false, false, false],
      timerangeErrors: [false, false, false, false],
      yearrangeError: [false, false, false, false],
      minDate: "",
      maxDate: "",
      minTime: "",
      maxTime: "",
      dateFormat: "",
      dateList: [
        { dateFormat: "YYYY-MM-DD" },
        { dateFormat: "DD-MM-YYYY" },
        { dateFormat: "MM-DD-YYYY" },
      ],
      timeFormat: "HH:mm:ss",

      // Grid config
      gridoption: "general",
      gridgeneral: "nav-link active",
      gridconfiguration: "nav-link",
      gridrows: [1],
      gridcolumns: [1],
      griddata: [{ Rows: [""], Columns: [""], Fieldtypes: ["text"] }],

      // Options/radio/dropdown
      optiongroups: { results: [] },
      selectedmodel: "",
      radiovalues: "",
      radiooptions: "",
      radiooptionsarray: [],
      dropdownError: false,
      editingOption: null,
      radioorientation: "horizontal",

      // Calculation field type (not the tab)
      calculate: { operations: "" },

      // Upload/Image (stubs)
      imageData: "",
      imagid: "fileId,1",
      fileuploadurl: "",
      iseditImage: false,

      // QR code
      qrcodecontents: "",
      emptyField: false,

      // Scales
      scaleminval: null,
      scalemaxval: null,
      scaleError: [false, false, false, false],

      // Year
      minYear: null,
      maxYear: null,

      // Custom validations tab
      exclusionMessages: [],
      exclusionMessagesError: [],
      conditionsArray: [],

      // Dependencies tab
      selectedOption: "no",
      dependencies: [],
      dependencyMessagesError: [],
      formList: [],
      fieldNames: [[]], // per dependency index list of target form fields
      selectedConditionsArray: [],

      // Calculations tab
      calculationsArray: [],
      calculationTemplateId: [],
      calculationMessagesError: [],
      dynamicFields: [],
      showSuggestions: [],
      filteredFields: [],
      showValidate: [],

      // Extras for edit-check integration
      selectedForm: "",
      selectedField: "",
      selectedFieldCondition: "",
      calculationFields: [],
      tempCalculationArray: [],
      tempCrossCalculationArray: [],
      tempCalcFields: [],
      newCalculationsArray: [],
      crossCalculationsArray: [],
      selectedFieldValue: "",
      showText: false,
      dateValidationrangeErrors: [],
      getVersion: null,

      // Aliases the edit-check API expects
      templateid: "",
      formname: "",
      version: "",
      type: "",
    };
  },

  computed: {
    allEditChecks() {
      const a = Array.isArray(this.exclusionMessages)
        ? this.exclusionMessages
        : [];
      const b = Array.isArray(this.generalValidations)
        ? this.generalValidations
        : [];
      return a.concat(b);
    },
    originalFieldName() {
      return this.value && this.value.fieldName
        ? String(this.value.fieldName)
        : "";
    },
    // For dependency value <select> when parent field is radio/dropdown
    selectedConditionValues() {
      return Array.isArray(this.radiooptionsarray)
        ? this.radiooptionsarray
        : [];
    },
  },

  watch: {
    modelValue(val) {
      if (typeof val === "boolean") {
        this.componentModal = val;
        if (val) this.initFromValue();
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler() {
        if (this.isHydrating) return;
        this.initFromValue();
      },
    },
    selectedmenu() {
      if (this.isHydrating) return;
      this.setupValidationOptions();
      this.setupConditionListForDependencies();
    },
  },

  async mounted() {
    try {
      this.isHydrating = true;

      // initialize validation option sets
      this.setupValidationOptions();

      // load forms for dependency tab
      await this.getDependencyForms();

      // hydrate from incoming field
      this.initFromValue();

      this.templateid = this.templateId;
      this.type = this.selectedmenu;

      // discover current form name + version
      if (Array.isArray(this.formList) && this.formList.length > 0) {
        const curForm = this.formList.find(function (f) {
          return String(f.templateId) === String(this.templateId);
        }, this);
        this.formname = curForm ? curForm.templateName || "" : "";
        this.version = curForm ? curForm.version || "" : "";
      }

      // fetch existing edit checks for this field (to populate tabs)
      if (this.value && this.value.fieldName) {
        const incomingType = this.value.type || this.selectedmenu || "textbox";
        const incomingValidation = Array.isArray(this.value.validation)
          ? this.value.validation
          : [];
        await this.geteditCheckValue(
          this.value.fieldName,
          incomingType,
          incomingValidation
        );
      }

      // conditions shown in dependency tab
      this.setupConditionListForDependencies();
    } catch (err) {
      console.error("mounted() init error:", err);
      this.$emit("error", err);
    } finally {
      this.isHydrating = false;
    }
  },

  methods: {
    /* ---------- Helpers used by edit-check flow ---------- */
    async getDependencyForms() {
      // Uses provided formlist API
      const idtoken = store.getters.getIdToken;
      const base = (this.baseurl || "").replace(/\/+$/, "");
      const url =
        base +
        "/forms/template/listtemplate?TemplateName=&StudyID=" +
        encodeURIComponent(store.getters.getStudyIs);

      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        const list =
          res && res.data && res.data.results ? res.data.results : [];
        // normalize to { templateId, templateName, version }
        const norm = list
          .map(function (x) {
            return {
              templateId: x && x.templateId != null ? String(x.templateId) : "",
              templateName:
                x && x.templateName != null ? String(x.templateName) : "",
              version: x && x.version != null ? String(x.version) : "",
            };
          })
          .sort(function (a, b) {
            return a.templateName.localeCompare(b.templateName);
          });

        this.formList = norm;
      } catch (err) {
        console.log("getDependencyForms error:", err);
        this.formList = [];
      }
    },

    setupConditionListForDependencies() {
      // Global library of conditions
      const base = [
        { value: "EQUAL TO", label: "Is equal to" },
        { value: "NOT EQUAL TO", label: "Is not equal to" },
      ];

      const numeric = base.concat([
        { value: "GREATER THAN", label: "Is greater than" },
        { value: "LESS THAN", label: "Is less than" },
      ]);

      const checkboxConds = base.concat([
        { value: "IS CHECKED ON", label: "Is checked on" },
        { value: "IS CHECKED OFF", label: "Is checked off" },
      ]);

      const s = String(this.selectedmenu || "").toLowerCase();
      if (s === "radio" || s === "dropdown" || s === "radiohorizondal") {
        this.selectedConditionsArray = base;
      } else if (
        s === "textbox" ||
        s === "text" ||
        s === "textarea" ||
        s === "date" ||
        s === "time" ||
        s === "year" ||
        s === "numberanddate" ||
        s === "dateandtime"
      ) {
        this.selectedConditionsArray = numeric;
      } else if (s === "checkbox") {
        this.selectedConditionsArray = checkboxConds;
      } else {
        this.selectedConditionsArray = base;
      }

      // Also expose a flattened list for other places if needed
      this.conditionsArray = this.selectedConditionsArray.slice();
    },

    async getConditionsandValues(type, validation) {
      this.selectedmenu = this.normalizeType(type);
      this.setupValidationOptions();
      this.values = Array.isArray(validation) ? validation.slice() : [];
      this.valuesChanged();
    },

    async geteditCheckValue(fieldname, type, validation) {
      // Reset state for tabs
      this.showSuggestions = [false];
      this.selectedForm = "";
      this.selectedField = "";
      this.selectedFieldCondition = "";
      this.exclusionMessages = [];
      this.generalValidations = [];
      this.selectedOption = "no";
      this.calculationFields = [];
      this.calculationsArray = [];
      this.tempCalculationArray = [];
      this.tempCrossCalculationArray = [];

      await this.getConditionsandValues(type, validation);
      await this.getDependencyForms();

      const base = (this.baseurl || "").replace(/\/+$/, "");
      const url =
        base +
        "/forms/editcheck/geteditcheckbyid?tempId=" +
        encodeURIComponent(this.templateId) +
        "&fieldName=" +
        encodeURIComponent(fieldname);

      try {
        const res = await axios.get(url, { headers: await this.authHeaders() });

        // Parse Edit Checks
        if (
          res &&
          res.data &&
          res.data.editCheck != null &&
          Array.isArray(res.data.editCheck) &&
          res.data.editCheck.length
        ) {
          // custom messages (non-basic conditions)
          this.exclusionMessages = res.data.editCheck
            .filter(function (edit) {
              return (
                [
                  "NUMBER",
                  "ALPHANUMERIC",
                  "NUMERICRANGE",
                  "DATERANGE",
                  "TIMERANGE",
                  "YEARRANGE",
                  "EMAIL",
                  "URL",
                  "CHARACTERLIMITRANGE",
                  "REQUIRED",
                  "PHONENUMBER",
                  "DATEFORMAT",
                  "TIMEFORMAT",
                ].indexOf(edit.condition) === -1
              );
            })
            .map(
              function (message) {
                if (
                  message &&
                  message.value &&
                  Array.isArray(message.value) &&
                  message.value.length > 0
                ) {
                  const dateConds = {
                    DATERANGE: 1,
                    "DATE GREATER THAN": 1,
                    "DATE EQUAL TO": 1,
                    "DATE LESS THAN": 1,
                    "DATE LESS THAN OR EQUAL TO": 1,
                    "DATE NOT EQUAL TO": 1,
                    "DATE GREATER THAN OR EQUAL TO": 1,
                    "OPTION TO AUTOFILL CURRENT DATE": 1,
                  };
                  if (dateConds[message.condition]) {
                    const value = message.value[0];
                    if (value instanceof Date) {
                      const y = value.getFullYear();
                      const m = String(value.getMonth() + 1).padStart(2, "0");
                      const d = String(value.getDate()).padStart(2, "0");
                      message.value[0] = y + "-" + m + "-" + d;
                    } else if (typeof value === "string") {
                      if (!isNaN(Date.parse(value))) {
                        const dt = new Date(value);
                        const y = dt.getFullYear();
                        const m = String(dt.getMonth() + 1).padStart(2, "0");
                        const d = String(dt.getDate()).padStart(2, "0");
                        message.value[0] = y + "-" + m + "-" + d;
                      }
                    }
                  }
                }
                if (this.normalizeType(type) === "year") {
                  if (
                    message.value &&
                    Array.isArray(message.value) &&
                    message.value.length
                  ) {
                    message.value[0] = parseInt(message.value[0], 10);
                  }
                }
                return message;
              }.bind(this)
            );

          // basic validations in "general" tab
          this.generalValidations = res.data.editCheck.filter(function (edit) {
            return (
              [
                "NUMBER",
                "ALPHANUMERIC",
                "NUMERICRANGE",
                "DATERANGE",
                "TIMERANGE",
                "YEARRANGE",
                "EMAIL",
                "URL",
                "CHARACTERLIMITRANGE",
                "REQUIRED",
                "PHONENUMBER",
                "DATEFORMAT",
                "TIMEFORMAT",
              ].indexOf(edit.condition) !== -1
            );
          });

          this.values = this.generalValidations.map(function (v) {
            return v.condition;
          });
          this.$nextTick(this.valuesChanged);
          this.generalValidationsError = this.generalValidations.map(
            function () {
              return [false, false];
            }
          );
        }

        // Dependencies (own + cross)
        const hasOwnDeps =
          res &&
          res.data &&
          Array.isArray(res.data.dependencies) &&
          res.data.dependencies.length > 0;

        const hasCrossDeps =
          res &&
          res.data &&
          Array.isArray(res.data.crossForms) &&
          res.data.crossForms.length > 0 &&
          res.data.crossForms[0] &&
          Array.isArray(res.data.crossForms[0].dependencies) &&
          res.data.crossForms[0].dependencies.length > 0;

        if (hasOwnDeps || hasCrossDeps) {
          this.selectedOption = "yes";
          this.dependencies = [];

          // own form deps
          if (hasOwnDeps) {
            const own = res.data.dependencies.map(
              function (dep) {
                return {
                  targetTemplateId: dep.targetTemplateId,
                  visibilityfieldname: dep.visibilityfieldname,
                  condition: this.normalizeCond(dep.condition),
                  value: dep.value,
                  isVisible:
                    dep.isVisible === true || dep.isVisible === false
                      ? dep.isVisible
                      : true,
                };
              }.bind(this)
            );
            this.dependencies = this.dependencies.concat(own);
          }

          // cross form deps
          if (hasCrossDeps) {
            res.data.crossForms.forEach(
              function (cf) {
                if (Array.isArray(cf.dependencies)) {
                  cf.dependencies.forEach(
                    function (dep) {
                      this.dependencies.push({
                        targetTemplateId: dep.targetTemplateId,
                        visibilityfieldname: dep.visibilityfieldname,
                        condition: this.normalizeCond(dep.condition),
                        value: dep.value,
                        isVisible:
                          dep.isVisible === true || dep.isVisible === false
                            ? dep.isVisible
                            : true,
                      });
                    }.bind(this)
                  );
                }
              }.bind(this)
            );
          }

          // normalize objects for selects
          for (let i = 0; i < this.dependencies.length; i++) {
            const dep = this.dependencies[i];

            // map targetTemplateId (string) to the full object from formList
            const found = this.formList.find(function (f) {
              return String(f.templateId) === String(dep.targetTemplateId);
            });
            if (found) {
              dep.targetTemplateId = found;
              this.getVersion = found.version;
            }

            // fetch fields for that form to populate visibilityfieldname dropdown
            if (dep.targetTemplateId && dep.targetTemplateId.templateId) {
              await this.getFields(
                dep.targetTemplateId.templateId,
                dep.targetTemplateId.version,
                i
              );
            }

            // map fieldName string -> full field object from fetched fieldNames[i]
            const fset = Array.isArray(this.fieldNames[i])
              ? this.fieldNames[i]
              : [];
            const fld = fset.find(function (ff) {
              return String(ff.fieldName) === String(dep.visibilityfieldname);
            });
            if (fld) dep.visibilityfieldname = fld;

            // If parent field is radio/dropdown, show optionname in UI but persist codevalue on save
            if (
              this.selectedmenu === "radio" ||
              this.selectedmenu === "dropdown" ||
              this.selectedmenu === "radiohorizondal"
            ) {
              dep.value = this.normalizeDepValueForOptions(dep.value);
            }
          }
        }

        // Calculations (own + cross)
        // Calculations (own + cross)
        const hasCalcs =
          res &&
          res.data &&
          Array.isArray(res.data.calculations) &&
          res.data.calculations.length > 0;
        const hasCrossCalcs =
          res && res.data && Array.isArray(res.data.crossForms);

        if (hasCalcs || hasCrossCalcs) {
          (res.data.calculations || []).forEach((item) => {
            if (item.outputfield === fieldname) {
              this.calculationsArray.push(item);
            } else {
              this.tempCalculationArray.push(item);
            }
          });

          if (Array.isArray(res.data.crossForms)) {
            res.data.crossForms.forEach((crossForm) => {
              (crossForm.calculations || []).forEach((crossCal) => {
                if (crossCal.outputfield === fieldname) {
                  this.calculationsArray.push(crossCal);
                } else {
                  this.tempCrossCalculationArray.push(crossCal);
                }
              });
            });
          }

          if (this.calculationsArray.length) {
            for (let i = 0; i < this.calculationsArray.length; i++) {
              const item = this.calculationsArray[i];
              let targetForm = null;

              if (
                item.crosstemplate &&
                item.crosstemplate[0] &&
                item.crosstemplate[0].targetTemplateId
              ) {
                targetForm = this.formList.find(
                  (f) =>
                    String(f.templateId) ===
                    String(item.crosstemplate[0].targetTemplateId)
                );
              } else {
                targetForm = this.formList.find(
                  (f) => String(f.templateId) === String(this.templateId)
                );
              }

              if (targetForm) {
                await this.getCalculationFields(
                  targetForm.templateId,
                  targetForm.version,
                  i
                );
                this.calculationTemplateId[i] = targetForm;
              }
            }
          }
        }

        if (!res.data) {
          this.dependencies = [];
          this.selectedOption = "no";
          this.selectedForm = "";
          this.selectedField = "";
          this.showText = false;
          this.selectedFieldCondition = "";
          this.selectedFieldValue = "";
          this.exclusionMessages = [];
          this.generalValidations = [];
          this.dateValidationrangeErrors = [];
          this.values = [];
          this.generalValidationsError = [];
        }
      } catch (err) {
        console.log("geteditCheckValue error:", err);
        this.$emit("error", err);
      }
    },

    /* ----------------------- UI BASICS ----------------------- */
    closemodaltwo() {
      if (this.modelValue !== undefined) this.$emit("update:modelValue", false);
      this.$emit("closeeditmodal");
    },
    handleTabClick(tab) {
      this.refreshFlags = {
        general: false,
        validation: false,
        dependencies: false,
        calculations: false,
      };
      this.refreshFlags[tab] = true;
    },

    selectconf(which) {
      this.gridoption = which;
      this.gridgeneral = which === "general" ? "nav-link active" : "nav-link";
      this.gridconfiguration =
        which === "configuration" ? "nav-link active" : "nav-link";
    },
    incrementrows() {
      this.gridrows.push(this.gridrows.length + 1);
      this.griddata[0].Rows.push("");
    },
    removerowsrows(i) {
      this.gridrows.splice(i, 1);
      this.griddata[0].Rows.splice(i, 1);
    },
    incrementcolumns() {
      this.gridcolumns.push(this.gridcolumns.length + 1);
      this.griddata[0].Columns.push("");
    },
    removecolumns(i) {
      this.gridcolumns.splice(i, 1);
      this.griddata[0].Columns.splice(i, 1);
    },

    /* ----------------------- GENERAL VALIDATIONS ----------------------- */
    setupValidationOptions() {
      const base = [
        { value: "REQUIRED", label: "REQUIRED" },
        { value: "ALPHANUMERIC", label: "ALPHANUMERIC" },
        { value: "NUMBER", label: "NUMBER" },
        { value: "NUMERICRANGE", label: "NUMERICRANGE" },
        { value: "CHARACTERLIMITRANGE", label: "CHARACTERLIMITRANGE" },
        { value: "EMAIL", label: "EMAIL" },
        { value: "URL", label: "URL" },
        { value: "PHONENUMBER", label: "PHONENUMBER" },
      ];
      const mk = function (extra) {
        return base.concat(extra);
      };

      // textbox / text
      this.options = mk([]);

      // radio / dropdown / checkbox share the "common" set
      this.commonvalidations = mk([]);

      // per-type lists used by the template
      this.generaldateOptions = mk([
        { value: "DATERANGE", label: "DATERANGE" },
        { value: "DATEFORMAT", label: "DATEFORMAT" },
      ]);
      this.generaltimeOptions = mk([
        { value: "TIMERANGE", label: "TIMERANGE" },
        { value: "TIMEFORMAT", label: "TIMEFORMAT" },
      ]);
      this.generalyearOptions = mk([
        { value: "YEARRANGE", label: "YEARRANGE" },
      ]);
      this.generalnumberanddateOptions = mk([
        { value: "NUMERICRANGE", label: "NUMERICRANGE" },
        { value: "DATERANGE", label: "DATERANGE" },
        { value: "DATEFORMAT", label: "DATEFORMAT" },
      ]);
      this.generaltextareaOptions = mk([
        { value: "CHARACTERLIMITRANGE", label: "CHARACTERLIMITRANGE" },
      ]);
      this.generaldateandtimeOptions = mk([
        { value: "DATERANGE", label: "DATERANGE" },
        { value: "DATEFORMAT", label: "DATEFORMAT" },
        { value: "TIMERANGE", label: "TIMERANGE" },
        { value: "TIMEFORMAT", label: "TIMEFORMAT" },
      ]);
    },

    valuesChanged() {
      const selected = {};
      for (let i = 0; i < this.values.length; i++) {
        selected[this.values[i]] = true;
      }

      // Remove unselected
      this.generalValidations = this.generalValidations.filter(function (v) {
        return !!selected[v.condition];
      });

      // Add missing
      for (let i = 0; i < this.values.length; i++) {
        const v = this.values[i];
        if (
          !this.generalValidations.find(function (x) {
            return x.condition === v;
          })
        ) {
          const needsTwo = {
            NUMERICRANGE: 1,
            CHARACTERLIMITRANGE: 1,
            DATERANGE: 1,
            TIMERANGE: 1,
            YEARRANGE: 1,
          };
          const needsOne = { DATEFORMAT: 1, TIMEFORMAT: 1 };
          this.generalValidations.push({
            condition: v,
            value: needsTwo[v] ? ["", ""] : needsOne[v] ? [""] : [],
            messageType: "",
            message: "",
          });
        }
      }
      this.generalValidationsError = this.generalValidations.map(function () {
        return [false, false];
      });
    },
    changeArray() {},
    deselectedOption(v) {
      this.generalValidations = this.generalValidations.filter(function (x) {
        return x.condition !== v;
      });
      this.generalValidationsError = this.generalValidations.map(function () {
        return [false, false];
      });
    },
    clearValues() {
      this.values = [];
      this.generalValidations = [];
      this.generalValidationsError = [];
    },

    /* ----------------------- OPTIONS ----------------------- */
    addradiooptions() {
      if (!this.radiovalues || !this.radiooptions) return;
      this.radiooptionsarray.push({
        codevalue: String(this.radiovalues),
        optionname: String(this.radiooptions),
      });
      this.radiovalues = "";
      this.radiooptions = "";
      this.editingOption = null;
    },
    UpdateDropdownoptions() {
      this.editingOption = null;
    },
    cancelEditDropdown() {
      this.editingOption = null;
    },
    editOptionsfordropdown(codevalue, optionname) {
      this.editingOption = { codevalue: codevalue, optionname: optionname };
      this.radiovalues = codevalue;
      this.radiooptions = optionname;
      this.$nextTick(function () {
        if (
          this.$refs &&
          this.$refs.codeValueInput &&
          typeof this.$refs.codeValueInput.focus === "function"
        ) {
          this.$refs.codeValueInput.focus();
        }
      });
    },
    deleteoptions(code) {
      this.radiooptionsarray = this.radiooptionsarray.filter(function (o) {
        return o.codevalue !== code;
      });
    },

    /* ----------------------- CUSTOM / DEP / CALCS ----------------------- */
    addValidation(scope) {
      if (scope === "custom") {
        this.exclusionMessages.push({
          condition: "",
          value: [""],
          messageType: "Warning",
          message: "",
        });
        this.exclusionMessagesError.push([false, false, false, false]);
      } else if (scope === "dependencies") {
        this.dependencies.push({
          targetTemplateId: null,
          visibilityfieldname: null,
          condition: "",
          value: "",
          isVisible: true,
        });
        this.dependencyMessagesError.push([false, false, false, false, false]);
        this.fieldNames.push([]);
      } else if (scope === "calculations") {
        this.calculationsArray.push({ expression: "" });
        this.showValidate.push(true);
        this.dynamicFields.push([]);
        this.calculationMessagesError.push([false]);
        this.calculationTemplateId.push(null);
      }
    },
    deleteMessage(scope, index) {
      if (scope === "general") this.generalValidations.splice(index, 1);
      if (scope === "custom") this.exclusionMessages.splice(index, 1);
      if (scope === "dependencies") {
        this.dependencies.splice(index, 1);
        this.fieldNames.splice(index, 1);
      }
      if (scope === "calculations") {
        this.calculationsArray.splice(index, 1);
        this.showValidate.splice(index, 1);
        this.dynamicFields.splice(index, 1);
      }
    },

    setDate(index, condition) {},
    preventNonNumericKeys(e) {
      const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
      if (!/[0-9]/.test(e.key) && allowed.indexOf(e.key) === -1)
        e.preventDefault();
    },
    validateYearInput() {},
    validateMinYear() {},
    validateMaxYear() {},
    validatedependencyYearInput(value, evt, index) {},

    /* ----------------------- API HELPERS ----------------------- */
    async authHeaders() {
      const h = { "Content-Type": "application/json" };
      if (this.idtoken) h["Authorization"] = "Bearer " + this.idtoken;
      return h;
    },

    async getFields(tid, ver, idx) {
      try {
        const base = (this.baseurl || "").replace(/\/+$/, "");
        const params =
          "?" +
          new URLSearchParams({
            tid: String(tid),
            ver: String(ver),
          }).toString();
        const url = base + this.endpoints.fields + params;

        // const res = await axios.get(url, { headers: await this.authHeaders() });
        const res = await axios.get(
          `${this.baseurl}/forms/templatedesign/listtemplatefields?formId=${tid}&version=${ver}`,
          {
            headers: await this.authHeaders(),
          }
        );
        const list = Array.isArray(res.data) ? res.data[0].field : [];

        // normalize to objects with fieldName (as template expects)
        const normalized = list.map(function (x) {
          if (x && typeof x === "object" && x.fieldName) return x;
          return { fieldName: String(x) };
        });

        const next = this.fieldNames.slice();
        next[idx] = normalized;
        this.fieldNames = next;
      } catch (e) {
        console.log("getFields error:", e);
        const next = this.fieldNames.slice();
        next[idx] = [];
        this.fieldNames = next;
      }
    },

    // Replace your current getCalculationFields with this
    async getCalculationFields(templateId, version, index) {
      try {
        // Fallbacks if args aren't passed
        const tid = templateId || this.templateId;
        const ver = version || this.getVersion || this.version || "";

        const base = (this.baseurl || "").replace(/\/+$/, "");
        const url = `${base}/forms/templatedesign/listtemplatefields?formId=${encodeURIComponent(
          tid
        )}&version=${encodeURIComponent(ver)}`;

        const res = await axios.get(url, { headers: await this.authHeaders() });

        // Expecting: res.data[0].field = [{ fieldName, type, ... }, ...]
        const fieldsArr =
          Array.isArray(res.data) &&
          res.data[0] &&
          Array.isArray(res.data[0].field)
            ? res.data[0].field
            : [];

        // Keep raw names list for this index (optional but handy elsewhere)
        const names = fieldsArr.map((f) =>
          f && typeof f === "object" && f.fieldName
            ? String(f.fieldName)
            : String(f || "")
        );

        // Suggestions list used by the calculations textarea (“@FieldName”)
        this.filteredFields = names.map((n) => "@" + n);

        // Also cache per-calc index if you use it elsewhere
        const calc = Array.isArray(this.calculationFields)
          ? this.calculationFields.slice()
          : [];
        calc[index] = names;
        this.calculationFields = calc;
      } catch (e) {
        console.log("getCalculationFields (original) error:", e);
        // Safe fallback so UI doesn't break
        this.filteredFields = ["@FieldA", "@FieldB", "@Total"];
      }
    },

    /* ----------------------- MAPPERS FOR OPTIONS ----------------------- */
    findOptionByAny(v) {
      if (v == null) return null;
      const s = String(v);
      return (
        this.radiooptionsarray.find(function (o) {
          return String(o.codevalue) === s || String(o.optionname) === s;
        }) || null
      );
    },
    toCodeValue(v) {
      const hit = this.findOptionByAny(v);
      return hit ? String(hit.codevalue) : v == null ? "" : String(v);
    },
    toOptionName(code) {
      const hit = this.radiooptionsarray.find(function (o) {
        return String(o.codevalue) === String(code);
      });
      return hit ? String(hit.optionname) : code == null ? "" : String(code);
    },
    normalizeDepValueForOptions(value) {
      const byName = this.radiooptionsarray.find(function (o) {
        return String(o.optionname) === String(value);
      });
      if (byName) return byName.optionname;
      const byCode = this.radiooptionsarray.find(function (o) {
        return String(o.codevalue) === String(value);
      });
      return byCode ? byCode.optionname : value;
    },

    /* ----------------------- CALC SUGGESTIONS ----------------------- */
    handleInput(ev) {
      const val =
        ev && ev.target && typeof ev.target.value === "string"
          ? ev.target.value
          : "";
      this.showSuggestions = this.calculationsArray.map(function () {
        return val.indexOf("@") !== -1;
      });
      if (!this.filteredFields || this.filteredFields.length === 0) {
        this.filteredFields = ["@FieldA", "@FieldB", "@Total"];
      }
    },
    handleKeydown(evt) {},
    selectSuggestion(field, expression, index) {
      const id = "calculationField-" + index;
      const textarea =
        typeof document !== "undefined" ? document.getElementById(id) : null;
      const expr = expression || "";
      if (!textarea) {
        const next = this.calculationsArray.slice();
        next[index] = {
          ...next[index],
          expression: (expr ? expr + " " : "") + field,
        };
        this.calculationsArray = next;
        const show = this.showSuggestions.slice();
        show[index] = false;
        this.showSuggestions = show;
        return;
      }
      const start = textarea.selectionStart || 0;
      const end = textarea.selectionEnd || 0;
      const before = expr.slice(0, start);
      const after = expr.slice(end);
      const combined = before + field + after;
      const next = this.calculationsArray.slice();
      next[index] = { ...next[index], expression: combined };
      this.calculationsArray = next;
      this.$nextTick(function () {
        textarea.focus();
        const pos = (before + field).length;
        textarea.selectionStart = pos;
        textarea.selectionEnd = pos;
      });
      const show = this.showSuggestions.slice();
      show[index] = false;
      this.showSuggestions = show;
    },
    inputFields(expression, index) {
      const show = this.showValidate.slice();
      const currentlyFalse = show[index] === false;
      show[index] = currentlyFalse ? true : false;
      this.showValidate = show;
      if (!currentlyFalse) {
        const dyn = this.dynamicFields.slice();
        dyn[index] = ["var1", "var2"];
        this.dynamicFields = dyn;
      }
    },

    /* ----------------------- NORMALIZE ----------------------- */
    normalizeType(t) {
      if (!t) return "textbox";
      const s = String(t).toLowerCase();
      if (["textbox", "text", "input"].indexOf(s) !== -1) return "textbox";
      if (["dropdown", "select"].indexOf(s) !== -1) return "dropdown";
      if (["radio", "radiobutton", "radiohorizondal"].indexOf(s) !== -1)
        return "radio";
      if (s === "date") return "date";
      if (s === "time") return "time";
      if (["textarea", "multiline"].indexOf(s) !== -1) return "textarea";
      if (["header", "heading"].indexOf(s) !== -1) return "header";
      if (["subheader", "subheading"].indexOf(s) !== -1) return "subHeader";
      if (["image", "picture"].indexOf(s) !== -1) return "image";
      if (s === "year") return "year";
      if (["dateandtime", "datetime"].indexOf(s) !== -1) return "dateandtime";
      if (s === "checkbox") return "checkbox";
      if (["scales", "scale"].indexOf(s) !== -1) return "scales";
      if (["calculation", "calculated"].indexOf(s) !== -1) return "calculation";
      if (s === "numberanddate") return "numberanddate";
      if (["qrcode", "qr"].indexOf(s) !== -1) return "qrcode";
      if (s === "addsurvey") return "addsurvey";
      if (s === "repeatedmeasure") return "repeatedmeasure";
      if (s === "repeatedmodel") return "repeatedmodel";
      return "textbox";
    },
    normalizeCond(c) {
      if (!c) return "";
      const s = String(c).trim().toUpperCase();
      const map = {
        "IS EQUAL TO": "EQUAL TO",
        "IS NOT EQUAL TO": "NOT EQUAL TO",
        "IS GREATER THAN": "GREATER THAN",
        "IS LESS THAN": "LESS THAN",
      };
      return map[s] || s;
    },

    /* ----------------------- INIT FROM INCOMING VALUE ----------------------- */
    initFromValue() {
      const v = this.value || {};

      this.fieldId = v && v.id ? v.id : null;
      this.fieldname = v && v.fieldName ? v.fieldName : "";
      this.labeltext = v && v.label ? v.label : "";
      // this.comments = v && v.comments ? v.comments : "";
      this.selectedmenu = this.normalizeType(v && v.type ? v.type : "textbox");
      this.isedit = !!(v && v.fieldName);

      // orientation (radio)
      this.radioorientation =
        v && v.align === "horizontal" ? "horizontal" : "vertical";

      // options normalization (for radio/dropdown)
      if (v && Array.isArray(v.options)) {
        this.radiooptionsarray = v.options.map(function (o) {
          if (o && typeof o === "object") {
            const code =
              o && o.codevalue != null
                ? o.codevalue
                : o && o.value != null
                ? o.value
                : o && o.optionname != null
                ? o.optionname
                : o && o.label != null
                ? o.label
                : "";
            const name =
              o && o.optionname != null
                ? o.optionname
                : o && o.label != null
                ? o.label
                : o && o.codevalue != null
                ? o.codevalue
                : o && o.value != null
                ? o.value
                : "";
            return { codevalue: String(code), optionname: String(name) };
          }
          const val = o == null ? "" : o;
          return { codevalue: String(val), optionname: String(val) };
        });
      } else {
        this.radiooptionsarray = [];
      }

      // validations (array of strings)
      this.setupValidationOptions();
      const incomingVals =
        v && Array.isArray(v.validation) ? v.validation.slice() : [];
      this.values = incomingVals;

      const needsTwo = {
        NUMERICRANGE: 1,
        CHARACTERLIMITRANGE: 1,
        DATERANGE: 1,
        TIMERANGE: 1,
        YEARRANGE: 1,
      };
      const needsOne = { DATEFORMAT: 1, TIMEFORMAT: 1 };
      this.generalValidations = incomingVals.map(function (cond) {
        return {
          condition: cond,
          value: needsTwo[cond] ? ["", ""] : needsOne[cond] ? [""] : [],
          messageType: "",
          message: "",
        };
      });
      this.generalValidationsError = this.generalValidations.map(function () {
        return [false, false];
      });
    },

    /* ----------------------- SERVER PAYLOAD (Update) ----------------------- */
    buildServerPayload() {
      const oldName = this.originalFieldName || this.fieldname;

      return {
        templateId: this.templateId,
        pageNo: this.pageNo,
        fieldName: String(oldName || "").trim(),
        field: {
          fieldName: String(this.fieldname || "").trim(),
          label: this.labeltext || "",
          status: "",
          comments: this.comments || "",
          limit: [],
          repeatingFields: [],
          groupOrderNo:
            this.grouporderno === 0 || this.grouporderno
              ? String(this.grouporderno)
              : "",
          type: this.selectedmenu,
          validation: Array.isArray(this.values) ? this.values : [],
          imagePath: this.imagid || "",
          options: Array.isArray(this.radiooptionsarray)
            ? this.radiooptionsarray
            : [],
          qrData: this.qrcodecontents || null,
          align:
            this.radioorientation === "horizontal" ? "horizontal" : "vertical",
          visibility: true,
        },
      };
    },

    /* ----------------------- SAVE / UPDATE / DELETE ----------------------- */
    async addfield() {
      const data = this.buildServerPayload();
      this.loadingBlock = true;
      try {
        await axios.put(
          (this.baseurl || "").replace(/\/+$/, "") +
            "/forms/templatedesign/updatefield",
          data,
          { headers: await this.authHeaders() }
        );

        // Sync aliases used by edit-checks
        this.templateid = this.templateId;
        this.type = this.selectedmenu;

        // Save edit-checks related to this field
        const ok = await this.editCheckValue("add");
        if (ok === false) return;

        this.isedit = true;
        this.$emit("saved", {
          action: "add",
          payload: data.field,
          pageNo: this.pageNo,
          indexOnPage: this.indexOnPage,
        });
        alert(
          this.$t
            ? this.$t("navigations.form updated successfully")
            : "Form updated successfully"
        );
        this.closemodaltwo();
      } catch (e) {
        console.log(
          "add field err:",
          e && e.response && e.response.data && e.response.data.detail
            ? e.response.data.detail
            : e
        );
        this.$emit("error", e);
      } finally {
        this.loadingBlock = false;
      }
    },

    async editfield() {
      const data = this.buildServerPayload();
      this.loadingBlock = true;
      try {
        await axios.put(
          (this.baseurl || "").replace(/\/+$/, "") +
            "/forms/templatedesign/updatefield",
          data,
          { headers: await this.authHeaders() }
        );

        // Sync aliases used by edit-checks
        this.templateid = this.templateId;
        this.type = this.selectedmenu;

        // Save edit-checks related to this field
        const ok = await this.editCheckValue("edit");
        if (ok === false) return;

        this.$emit("saved", {
          action: "edit",
          payload: data.field,
          pageNo: this.pageNo,
          indexOnPage: this.indexOnPage,
        });
        alert("Form updated successfully");
        this.closemodaltwo();
      } catch (e) {
        console.log(
          "update field err:",
          e && e.response && e.response.data && e.response.data.detail
            ? e.response.data.detail
            : e
        );
        this.$emit("error", e);
      } finally {
        this.loadingBlock = false;
      }
    },

    async deletecomponent() {
      const targetName = this.originalFieldName
        ? this.originalFieldName
        : this.fieldname;
      if (!targetName) return;
      this.loadingBlock = true;
      try {
        await axios.delete(
          (this.baseurl || "").replace(/\/+$/, "") +
            "/forms/templatedesign/deletefield",
          {
            headers: await this.authHeaders(),
            data: {
              templateId: this.templateId,
              pageNo: this.pageNo,
              fieldName: String(targetName).trim(),
            },
          }
        );
        this.$emit("deleted", { id: String(targetName).trim() });
        this.closemodaltwo();
      } catch (e) {
        this.$emit("error", e);
      } finally {
        this.loadingBlock = false;
      }
    },

    /* ----------------------- EDIT-CHECK SAVE ----------------------- */
    async editCheckValue(funcType) {
      this.crossCalculationsArray = [];

      // General validations payload + basic checks
      if (this.generalValidations.length !== 0) {
        const conditionValueMap = {
          NUMERICRANGE: [
            this.minvalue != null ? this.minvalue.toString() : "",
            this.maxvalue != null ? this.maxvalue.toString() : "",
          ],
          DATEFORMAT: [this.dateFormat ? this.dateFormat.toString() : ""],
          DATERANGE: [
            this.minDate ? this.minDate.toString() : "",
            this.maxDate ? this.maxDate.toString() : "",
          ],
          TIMEFORMAT: [this.timeFormat],
          TIMERANGE: [
            this.minTime ? this.minTime.toString() : "",
            this.maxTime ? this.maxTime.toString() : "",
          ],
          YEARRANGE: [
            this.minYear != null ? this.minYear.toString() : "",
            this.maxYear != null ? this.maxYear.toString() : "",
          ],
          CHARACTERLIMITRANGE: [
            this.minlength != null ? this.minlength.toString() : "",
            this.maxlength != null ? this.maxlength.toString() : "",
          ],
        };

        this.generalValidations.forEach(
          function (validation) {
            if (
              validation.condition &&
              conditionValueMap[validation.condition]
            ) {
              validation.value = conditionValueMap[validation.condition];
            }
          }.bind(this)
        );

        this.generalValidationsError = this.generalValidations.map(function (
          validation
        ) {
          const errors = [false, false];
          if (validation.condition) {
            if (!validation.messageType) errors[0] = true;
            if (!validation.message) errors[1] = true;
          }
          return errors;
        });

        if (
          this.generalValidationsError.some(function (error) {
            return error.indexOf(true) !== -1;
          })
        ) {
          alert("Please fill all values for general validations");
          this.loadingBlock = false;
        }
      }

      // Custom validations tab
      if (this.exclusionMessages.length > 0) {
        this.exclusionMessages.forEach(function (message) {
          if (
            [
              "DATERANGE",
              "DATE GREATER THAN",
              "DATE EQUAL TO",
              "DATE LESS THAN",
              "DATE LESS THAN OR EQUAL TO",
              "DATE NOT EQUAL TO",
              "OPTION TO AUTOFILL CURRENT DATE",
            ].indexOf(message.condition) !== -1
          ) {
            const value =
              message.value && message.value.length ? message.value[0] : "";
            if (value instanceof Date) {
              const day = String(value.getDate()).padStart(2, "0");
              const month = String(value.getMonth() + 1).padStart(2, "0");
              const year = value.getFullYear();
              message.value[0] = day + "-" + month + "-" + year;
            } else if (typeof value === "string" && !isNaN(Date.parse(value))) {
              const date = new Date(value);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              message.value[0] = day + "-" + month + "-" + year;
            }
          }
          if (message.condition === "IS CHECKED ON") {
            message.value[0] = "true";
          }
          if (message.condition === "IS CHECKED OFF") {
            message.value[0] = "false";
          }
        });

        this.exclusionMessagesError = this.exclusionMessages.map(function (
          validation
        ) {
          const errors = [false, false, false, false];
          if (!validation.condition) errors[0] = true;
          if (!validation.messageType) errors[1] = true;
          if (!validation.message) errors[2] = true;
          if (!validation.value || validation.value.length === 0)
            errors[3] = true;
          return errors;
        });

        const hasErrors = this.exclusionMessagesError.some(function (error) {
          return error.indexOf(true) !== -1;
        });
        if (hasErrors) {
          alert("Please fill all values for custom validations");
          this.loadingBlock = false;
        }
      }

      // Calculations tab
      if (this.calculationsArray.length > 0) {
        this.calculationMessagesError = this.calculationsArray.map(function (
          validation
        ) {
          const errors = [false];
          if (!validation.expression) errors[0] = true;
          return errors;
        });

        const hasErrors = this.calculationMessagesError.some(function (error) {
          return error.indexOf(true) !== -1;
        });
        if (hasErrors) {
          alert("Please fill all values for calculations");
          this.loadingBlock = false;
        }
      }

      // Dependencies tab
      if (this.selectedOption === "yes") {
        this.dependencies.forEach(function (dependency) {
          if (dependency.condition === "IS CHECKED ON")
            dependency.value = "true";
          if (dependency.condition === "IS CHECKED OFF")
            dependency.value = "false";
        });

        this.dependencyMessagesError = this.dependencies.map(function (
          validation
        ) {
          const errors = [false, false, false, false, false];
          if (!validation.targetTemplateId) errors[0] = true;
          if (!validation.visibilityfieldname) errors[1] = true;
          if (!validation.condition) errors[2] = true;
          if (
            !validation.value ||
            (Array.isArray(validation.value) && validation.value.length === 0)
          )
            errors[3] = true;
          if (
            validation.isVisible === null ||
            validation.isVisible === undefined
          )
            errors[4] = true;
          return errors;
        });

        const hasErrors = this.dependencyMessagesError.some(function (error) {
          return error.indexOf(true) !== -1;
        });
        if (hasErrors) {
          alert("Please fill all values for dependency");
          this.loadingBlock = false;
        }
      }

      const anyGeneralErr = this.generalValidationsError.some(function (e) {
        return e.indexOf(true) !== -1;
      });
      const anyCustomErr = this.exclusionMessagesError.some(function (e) {
        return e.indexOf(true) !== -1;
      });
      const anyDepErr = this.dependencyMessagesError.some(function (e) {
        return e.indexOf(true) !== -1;
      });
      const anyCalcErr = this.calculationMessagesError.some(function (e) {
        return e.indexOf(true) !== -1;
      });

      if (!anyGeneralErr && !anyCustomErr && !anyDepErr && !anyCalcErr) {
        // If selectedField is date, normalize selectedFieldValue
        if (this.selectedField && this.selectedField.type === "date") {
          let selectedDate = this.selectedFieldValue;
          if (selectedDate instanceof Date) {
            const day = String(selectedDate.getDate()).padStart(2, "0");
            const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
            const year = selectedDate.getFullYear();
            this.selectedFieldValue = day + "-" + month + "-" + year;
          } else if (
            typeof selectedDate === "string" &&
            !isNaN(Date.parse(selectedDate))
          ) {
            const date = new Date(selectedDate);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            this.selectedFieldValue = day + "-" + month + "-" + year;
          }
        }

        // split dependencies into own form vs cross form
        const regularDependencies = [];
        const crossFormDependencies = [];

        for (let i = 0; i < this.dependencies.length; i++) {
          const item = this.dependencies[i];

          const transformed = {
            targetTemplateId:
              item && item.targetTemplateId
                ? item.targetTemplateId.templateId
                : "",
            targetFieldName: "",
            condition: this.normalizeCond(item ? item.condition : ""),
            value: this.toCodeValue(item ? item.value : ""), // persist codevalue
            pageNo: "1",
            isVisible: item ? item.isVisible : true,
            visibilityfieldname:
              item && item.visibilityfieldname
                ? item.visibilityfieldname.fieldName
                : "",
          };

          const matchedForm =
            item &&
            item.targetTemplateId &&
            item.targetTemplateId.templateId === this.templateid;

          if (matchedForm) {
            this.getVersion =
              item && item.targetTemplateId
                ? item.targetTemplateId.version
                : this.getVersion;
            regularDependencies.push(transformed);
          } else {
            transformed.targetFieldName =
              item && item.visibilityfieldname
                ? item.visibilityfieldname.fieldName
                : "";
            crossFormDependencies.push(transformed);
          }
        }

        // Calculations regrouping (kept minimal)
        if (
          this.calculationsArray &&
          this.calculationsArray.length !== 0 &&
          this.calculationsArray[0].expression !== ""
        ) {
          this.newCalculationsArray = [];
          this.crossCalculationsArray = [];

          this.calculationsArray.forEach(
            function (item) {
              if (!item.fields || item.fields.length === 0) {
                const matches = item.expression.match(/\{([^}]+)\}/g);
                item.fields = matches
                  ? Array.from(
                      new Set(
                        matches.map(function (field) {
                          return field.slice(1, -1);
                        })
                      )
                    )
                  : [];
              }
              item.outputfield = this.fieldname;

              // naive assumption: keep on same form unless cross detected elsewhere
              this.newCalculationsArray.push({
                fields: item.fields,
                expression: item.expression,
                outputfield: item.outputfield,
              });
            }.bind(this)
          );

          this.newCalculationsArray = this.newCalculationsArray.concat(
            this.tempCalculationArray
          );
          this.crossCalculationsArray = this.tempCrossCalculationArray.slice();
        } else {
          this.newCalculationsArray = [];
          this.crossCalculationsArray = [];
          this.newCalculationsArray = this.newCalculationsArray.concat(
            this.tempCalculationArray
          );
          this.crossCalculationsArray = this.crossCalculationsArray.concat(
            this.tempCrossCalculationArray
          );
        }

        const editCheckData = {
          templateId: this.templateid,
          formName: this.formname,
          studyId: store.getters.getStudyIs,
          version: this.version,
          fields: [
            {
              fieldName: String(this.fieldname || "").trim(),
              type: this.type,
              editCheck: this.exclusionMessages,
              dependencies:
                this.selectedOption === "yes" && this.dependencies
                  ? regularDependencies
                  : [],
              calculations:
                this.newCalculationsArray.length !== 0
                  ? this.newCalculationsArray.filter(function (calc) {
                      return calc.expression && calc.expression.trim() !== "";
                    })
                  : [],
              crossForms:
                crossFormDependencies.length === 0 &&
                this.crossCalculationsArray.length === 0
                  ? []
                  : [
                      {
                        editCheck: null,
                        dependencies: crossFormDependencies,
                        calculations: this.crossCalculationsArray,
                      },
                    ],
            },
          ],
        };

        try {
          await axios.post(
            this.baseurl + "/forms/editcheck/createeditcheck",
            editCheckData,
            {
              headers: {
                Authorization: "Bearer " + this.idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          if (funcType === "edit") {
            console.log("Edit check added");
          }
          if (typeof this.gettemplatebytempid === "function") {
            await this.gettemplatebytempid(this.templateid);
          }
          if (typeof this.loadvisibilities === "function") {
            this.loadvisibilities();
          }
          return true;
        } catch (err) {
          this.loadingBlock = false;
          alert("Edit-check creation failed");
          return false;
        }
      }
    },

    /* ----------------------- MISC ----------------------- */
    dropdownmodelchange() {},
    handleChange() {},
    modelchange() {},
    addmodel() {},
    addrepeatedmeasure() {},
    onFileeditchange() {},
    clearInput() {
      this.scaleError = [false, false, false, false];
    },
    changetoDefault() {},

    // Safe no-ops if host doesn't provide these
    async gettemplatebytempid() {},
    loadvisibilities() {},
    togglePopover(field, event) {

  if (this.activePopover) {
    this.activePopover.dispose()
    this.activePopover = null
    return
  }

  const baseTemplate = document.getElementById('commentPopoverTemplate')
  if (!baseTemplate) return

  const template = baseTemplate.cloneNode(true)

  const commentDiv = template.querySelector('#commentText')
  commentDiv.innerText =
    field.comments && field.comments.trim()
      ? field.comments
      : 'No comment available'

  this.activePopover = new bootstrap.Popover(event.target, {
    html: true,
    content: template.innerHTML,
    placement: 'right',
    trigger: 'manual',
    container: 'body'
  })

  this.activePopover.show()

  // auto close on outside click
  document.addEventListener(
    'click',
    (e) => {
      if (!event.target.contains(e.target)) {
        this.activePopover?.dispose()
        this.activePopover = null
      }
    },
    { once: true }
  )
},

 hasComments(field) {
    return field?.comments && field.comments.trim().length > 0;
  },
  },
};
</script>


<style scoped>
.modalcontents {
  overflow: auto;
  max-height: calc(90vh - 110px);
}
.errormsg {
  color: #c0392b;
  font-size: 12px;
}
.icon-color {
  cursor: pointer;
}
.suggestions {
  list-style: none;
  margin: 0.5rem 0;
  padding: 0.5rem;
  border: 1px solid #eee;
  border-radius: 6px;
}
.suggestions li {
  padding: 0.25rem 0.5rem;
  cursor: pointer;
}
.suggestions li:hover {
  background: #f5f5f5;
}
.loading-btn-img {
  vertical-align: middle;
}
.disabled-btn {
  opacity: 0.6;
  cursor: not-allowed;
}
.nav-link.active {
  font-weight: 600;
}
.study-select {
  width: 100%;
}
.select-padding {
  padding: 0.375rem 0.75rem;
}
</style>
